import mn, { useRef as Xr, useCallback as Ga, useEffect as cr, useContext as $n, useState as lr, createContext as xn, memo as _e } from "react";
function Sp(e, r) {
  const t = Xr();
  return Ga(
    (...n) => {
      t.current && clearTimeout(t.current), t.current = setTimeout(() => {
        e(...n);
      }, r);
    },
    [r, e]
  );
}
const Cp = (e) => {
  const r = Xr(null);
  return cr(() => {
    const t = (n) => {
      r.current && !r.current.contains(n.target) && e();
    };
    return document.addEventListener("click", t), () => {
      document.removeEventListener("click", t);
    };
  }, [r]), r;
}, Ep = () => {
  const e = $n(window.I18nContext), [r, t] = lr(e.i18n), { i18n: n, locale: a, setLocale: o } = e;
  return cr(() => n.onChange((b) => {
    t(
      Object.assign(
        Object.create(Object.getPrototypeOf(b)),
        b
      )
    );
  }), []), { i18n: r, locale: a, setLocale: o };
};
var ir = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function be(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zr = { exports: {} }, Ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ot;
function Wa() {
  if (Ot)
    return Ye;
  Ot = 1;
  var e = mn, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(b, m, x) {
    var C, E = {}, T = null, R = null;
    x !== void 0 && (T = "" + x), m.key !== void 0 && (T = "" + m.key), m.ref !== void 0 && (R = m.ref);
    for (C in m)
      n.call(m, C) && !o.hasOwnProperty(C) && (E[C] = m[C]);
    if (b && b.defaultProps)
      for (C in m = b.defaultProps, m)
        E[C] === void 0 && (E[C] = m[C]);
    return { $$typeof: r, type: b, key: T, ref: R, props: E, _owner: a.current };
  }
  return Ye.Fragment = t, Ye.jsx = d, Ye.jsxs = d, Ye;
}
var Ke = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var St;
function Va() {
  return St || (St = 1, process.env.NODE_ENV !== "production" && function() {
    var e = mn, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), b = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), C = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), N = Symbol.iterator, k = "@@iterator";
    function H(u) {
      if (u === null || typeof u != "object")
        return null;
      var S = N && u[N] || u[k];
      return typeof S == "function" ? S : null;
    }
    var V = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(u) {
      {
        for (var S = arguments.length, A = new Array(S > 1 ? S - 1 : 0), I = 1; I < S; I++)
          A[I - 1] = arguments[I];
        oe("error", u, A);
      }
    }
    function oe(u, S, A) {
      {
        var I = V.ReactDebugCurrentFrame, B = I.getStackAddendum();
        B !== "" && (S += "%s", A = A.concat([B]));
        var W = A.map(function(U) {
          return String(U);
        });
        W.unshift("Warning: " + S), Function.prototype.apply.call(console[u], console, W);
      }
    }
    var ue = !1, ae = !1, te = !1, ie = !1, i = !1, s;
    s = Symbol.for("react.module.reference");
    function l(u) {
      return !!(typeof u == "string" || typeof u == "function" || u === n || u === o || i || u === a || u === x || u === C || ie || u === R || ue || ae || te || typeof u == "object" && u !== null && (u.$$typeof === T || u.$$typeof === E || u.$$typeof === d || u.$$typeof === b || u.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      u.$$typeof === s || u.getModuleId !== void 0));
    }
    function v(u, S, A) {
      var I = u.displayName;
      if (I)
        return I;
      var B = S.displayName || S.name || "";
      return B !== "" ? A + "(" + B + ")" : A;
    }
    function f(u) {
      return u.displayName || "Context";
    }
    function h(u) {
      if (u == null)
        return null;
      if (typeof u.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof u == "function")
        return u.displayName || u.name || null;
      if (typeof u == "string")
        return u;
      switch (u) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case x:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case b:
            var S = u;
            return f(S) + ".Consumer";
          case d:
            var A = u;
            return f(A._context) + ".Provider";
          case m:
            return v(u, u.render, "ForwardRef");
          case E:
            var I = u.displayName || null;
            return I !== null ? I : h(u.type) || "Memo";
          case T: {
            var B = u, W = B._payload, U = B._init;
            try {
              return h(U(W));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var y = Object.assign, c = 0, p, _, g, w, j, P, D;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function J() {
      {
        if (c === 0) {
          p = console.log, _ = console.info, g = console.warn, w = console.error, j = console.group, P = console.groupCollapsed, D = console.groupEnd;
          var u = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: u,
            log: u,
            warn: u,
            error: u,
            group: u,
            groupCollapsed: u,
            groupEnd: u
          });
        }
        c++;
      }
    }
    function L() {
      {
        if (c--, c === 0) {
          var u = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: y({}, u, {
              value: p
            }),
            info: y({}, u, {
              value: _
            }),
            warn: y({}, u, {
              value: g
            }),
            error: y({}, u, {
              value: w
            }),
            group: y({}, u, {
              value: j
            }),
            groupCollapsed: y({}, u, {
              value: P
            }),
            groupEnd: y({}, u, {
              value: D
            })
          });
        }
        c < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = V.ReactCurrentDispatcher, Q;
    function we(u, S, A) {
      {
        if (Q === void 0)
          try {
            throw Error();
          } catch (B) {
            var I = B.stack.trim().match(/\n( *(at )?)/);
            Q = I && I[1] || "";
          }
        return `
` + Q + u;
      }
    }
    var Pe = !1, Te;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      Te = new de();
    }
    function Ae(u, S) {
      if (!u || Pe)
        return "";
      {
        var A = Te.get(u);
        if (A !== void 0)
          return A;
      }
      var I;
      Pe = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var W;
      W = z.current, z.current = null, J();
      try {
        if (S) {
          var U = function() {
            throw Error();
          };
          if (Object.defineProperty(U.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(U, []);
            } catch (Oe) {
              I = Oe;
            }
            Reflect.construct(u, [], U);
          } else {
            try {
              U.call();
            } catch (Oe) {
              I = Oe;
            }
            u.call(U.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Oe) {
            I = Oe;
          }
          u();
        }
      } catch (Oe) {
        if (Oe && I && typeof Oe.stack == "string") {
          for (var F = Oe.stack.split(`
`), se = I.stack.split(`
`), X = F.length - 1, ee = se.length - 1; X >= 1 && ee >= 0 && F[X] !== se[ee]; )
            ee--;
          for (; X >= 1 && ee >= 0; X--, ee--)
            if (F[X] !== se[ee]) {
              if (X !== 1 || ee !== 1)
                do
                  if (X--, ee--, ee < 0 || F[X] !== se[ee]) {
                    var he = `
` + F[X].replace(" at new ", " at ");
                    return u.displayName && he.includes("<anonymous>") && (he = he.replace("<anonymous>", u.displayName)), typeof u == "function" && Te.set(u, he), he;
                  }
                while (X >= 1 && ee >= 0);
              break;
            }
        }
      } finally {
        Pe = !1, z.current = W, L(), Error.prepareStackTrace = B;
      }
      var Le = u ? u.displayName || u.name : "", wt = Le ? we(Le) : "";
      return typeof u == "function" && Te.set(u, wt), wt;
    }
    function le(u, S, A) {
      return Ae(u, !1);
    }
    function ne(u) {
      var S = u.prototype;
      return !!(S && S.isReactComponent);
    }
    function G(u, S, A) {
      if (u == null)
        return "";
      if (typeof u == "function")
        return Ae(u, ne(u));
      if (typeof u == "string")
        return we(u);
      switch (u) {
        case x:
          return we("Suspense");
        case C:
          return we("SuspenseList");
      }
      if (typeof u == "object")
        switch (u.$$typeof) {
          case m:
            return le(u.render);
          case E:
            return G(u.type, S, A);
          case T: {
            var I = u, B = I._payload, W = I._init;
            try {
              return G(W(B), S, A);
            } catch {
            }
          }
        }
      return "";
    }
    var nr = Object.prototype.hasOwnProperty, ft = {}, dt = V.ReactDebugCurrentFrame;
    function ar(u) {
      if (u) {
        var S = u._owner, A = G(u.type, u._source, S ? S.type : null);
        dt.setExtraStackFrame(A);
      } else
        dt.setExtraStackFrame(null);
    }
    function Oa(u, S, A, I, B) {
      {
        var W = Function.call.bind(nr);
        for (var U in u)
          if (W(u, U)) {
            var F = void 0;
            try {
              if (typeof u[U] != "function") {
                var se = Error((I || "React class") + ": " + A + " type `" + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[U] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw se.name = "Invariant Violation", se;
              }
              F = u[U](S, U, I, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (X) {
              F = X;
            }
            F && !(F instanceof Error) && (ar(B), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", A, U, typeof F), ar(null)), F instanceof Error && !(F.message in ft) && (ft[F.message] = !0, ar(B), $("Failed %s type: %s", A, F.message), ar(null));
          }
      }
    }
    var Sa = Array.isArray;
    function Or(u) {
      return Sa(u);
    }
    function Ca(u) {
      {
        var S = typeof Symbol == "function" && Symbol.toStringTag, A = S && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return A;
      }
    }
    function Ea(u) {
      try {
        return ht(u), !1;
      } catch {
        return !0;
      }
    }
    function ht(u) {
      return "" + u;
    }
    function pt(u) {
      if (Ea(u))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ca(u)), ht(u);
    }
    var qe = V.ReactCurrentOwner, Ta = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, gt, vt, Sr;
    Sr = {};
    function Aa(u) {
      if (nr.call(u, "ref")) {
        var S = Object.getOwnPropertyDescriptor(u, "ref").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return u.ref !== void 0;
    }
    function ja(u) {
      if (nr.call(u, "key")) {
        var S = Object.getOwnPropertyDescriptor(u, "key").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return u.key !== void 0;
    }
    function Pa(u, S) {
      if (typeof u.ref == "string" && qe.current && S && qe.current.stateNode !== S) {
        var A = h(qe.current.type);
        Sr[A] || ($('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', h(qe.current.type), u.ref), Sr[A] = !0);
      }
    }
    function Ra(u, S) {
      {
        var A = function() {
          gt || (gt = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        A.isReactWarning = !0, Object.defineProperty(u, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function Ia(u, S) {
      {
        var A = function() {
          vt || (vt = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        A.isReactWarning = !0, Object.defineProperty(u, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var Ma = function(u, S, A, I, B, W, U) {
      var F = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: u,
        key: S,
        ref: A,
        props: U,
        // Record the component responsible for creating this element.
        _owner: W
      };
      return F._store = {}, Object.defineProperty(F._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(F, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(F, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.freeze && (Object.freeze(F.props), Object.freeze(F)), F;
    };
    function Na(u, S, A, I, B) {
      {
        var W, U = {}, F = null, se = null;
        A !== void 0 && (pt(A), F = "" + A), ja(S) && (pt(S.key), F = "" + S.key), Aa(S) && (se = S.ref, Pa(S, B));
        for (W in S)
          nr.call(S, W) && !Ta.hasOwnProperty(W) && (U[W] = S[W]);
        if (u && u.defaultProps) {
          var X = u.defaultProps;
          for (W in X)
            U[W] === void 0 && (U[W] = X[W]);
        }
        if (F || se) {
          var ee = typeof u == "function" ? u.displayName || u.name || "Unknown" : u;
          F && Ra(U, ee), se && Ia(U, ee);
        }
        return Ma(u, F, se, B, I, qe.current, U);
      }
    }
    var Cr = V.ReactCurrentOwner, _t = V.ReactDebugCurrentFrame;
    function De(u) {
      if (u) {
        var S = u._owner, A = G(u.type, u._source, S ? S.type : null);
        _t.setExtraStackFrame(A);
      } else
        _t.setExtraStackFrame(null);
    }
    var Er;
    Er = !1;
    function Tr(u) {
      return typeof u == "object" && u !== null && u.$$typeof === r;
    }
    function bt() {
      {
        if (Cr.current) {
          var u = h(Cr.current.type);
          if (u)
            return `

Check the render method of \`` + u + "`.";
        }
        return "";
      }
    }
    function Fa(u) {
      {
        if (u !== void 0) {
          var S = u.fileName.replace(/^.*[\\\/]/, ""), A = u.lineNumber;
          return `

Check your code at ` + S + ":" + A + ".";
        }
        return "";
      }
    }
    var yt = {};
    function Da(u) {
      {
        var S = bt();
        if (!S) {
          var A = typeof u == "string" ? u : u.displayName || u.name;
          A && (S = `

Check the top-level render call using <` + A + ">.");
        }
        return S;
      }
    }
    function mt(u, S) {
      {
        if (!u._store || u._store.validated || u.key != null)
          return;
        u._store.validated = !0;
        var A = Da(S);
        if (yt[A])
          return;
        yt[A] = !0;
        var I = "";
        u && u._owner && u._owner !== Cr.current && (I = " It was passed a child from " + h(u._owner.type) + "."), De(u), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, I), De(null);
      }
    }
    function $t(u, S) {
      {
        if (typeof u != "object")
          return;
        if (Or(u))
          for (var A = 0; A < u.length; A++) {
            var I = u[A];
            Tr(I) && mt(I, S);
          }
        else if (Tr(u))
          u._store && (u._store.validated = !0);
        else if (u) {
          var B = H(u);
          if (typeof B == "function" && B !== u.entries)
            for (var W = B.call(u), U; !(U = W.next()).done; )
              Tr(U.value) && mt(U.value, S);
        }
      }
    }
    function La(u) {
      {
        var S = u.type;
        if (S == null || typeof S == "string")
          return;
        var A;
        if (typeof S == "function")
          A = S.propTypes;
        else if (typeof S == "object" && (S.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        S.$$typeof === E))
          A = S.propTypes;
        else
          return;
        if (A) {
          var I = h(S);
          Oa(A, u.props, "prop", I, u);
        } else if (S.PropTypes !== void 0 && !Er) {
          Er = !0;
          var B = h(S);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", B || "Unknown");
        }
        typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ua(u) {
      {
        for (var S = Object.keys(u.props), A = 0; A < S.length; A++) {
          var I = S[A];
          if (I !== "children" && I !== "key") {
            De(u), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), De(null);
            break;
          }
        }
        u.ref !== null && (De(u), $("Invalid attribute `ref` supplied to `React.Fragment`."), De(null));
      }
    }
    function xt(u, S, A, I, B, W) {
      {
        var U = l(u);
        if (!U) {
          var F = "";
          (u === void 0 || typeof u == "object" && u !== null && Object.keys(u).length === 0) && (F += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var se = Fa(B);
          se ? F += se : F += bt();
          var X;
          u === null ? X = "null" : Or(u) ? X = "array" : u !== void 0 && u.$$typeof === r ? (X = "<" + (h(u.type) || "Unknown") + " />", F = " Did you accidentally export a JSX literal instead of a component?") : X = typeof u, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", X, F);
        }
        var ee = Na(u, S, A, B, W);
        if (ee == null)
          return ee;
        if (U) {
          var he = S.children;
          if (he !== void 0)
            if (I)
              if (Or(he)) {
                for (var Le = 0; Le < he.length; Le++)
                  $t(he[Le], u);
                Object.freeze && Object.freeze(he);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              $t(he, u);
        }
        return u === n ? Ua(ee) : La(ee), ee;
      }
    }
    function za(u, S, A) {
      return xt(u, S, A, !0);
    }
    function Ba(u, S, A) {
      return xt(u, S, A, !1);
    }
    var ka = Ba, Ha = za;
    Ke.Fragment = n, Ke.jsx = ka, Ke.jsxs = Ha;
  }()), Ke;
}
process.env.NODE_ENV === "production" ? zr.exports = Wa() : zr.exports = Va();
var O = zr.exports, qa = Array.isArray, xe = qa, Ya = typeof ir == "object" && ir && ir.Object === Object && ir, wn = Ya, Ka = wn, Za = typeof self == "object" && self && self.Object === Object && self, Ja = Ka || Za || Function("return this")(), Ee = Ja, Xa = Ee, Qa = Xa.Symbol, Xe = Qa, Ct = Xe, On = Object.prototype, ei = On.hasOwnProperty, ri = On.toString, Ze = Ct ? Ct.toStringTag : void 0;
function ti(e) {
  var r = ei.call(e, Ze), t = e[Ze];
  try {
    e[Ze] = void 0;
    var n = !0;
  } catch {
  }
  var a = ri.call(e);
  return n && (r ? e[Ze] = t : delete e[Ze]), a;
}
var ni = ti, ai = Object.prototype, ii = ai.toString;
function si(e) {
  return ii.call(e);
}
var oi = si, Et = Xe, ui = ni, li = oi, ci = "[object Null]", fi = "[object Undefined]", Tt = Et ? Et.toStringTag : void 0;
function di(e) {
  return e == null ? e === void 0 ? fi : ci : Tt && Tt in Object(e) ? ui(e) : li(e);
}
var Qe = di;
function hi(e) {
  return e != null && typeof e == "object";
}
var er = hi, pi = Qe, gi = er, vi = "[object Symbol]";
function _i(e) {
  return typeof e == "symbol" || gi(e) && pi(e) == vi;
}
var rr = _i, bi = xe, yi = rr, mi = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $i = /^\w*$/;
function xi(e, r) {
  if (bi(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || yi(e) ? !0 : $i.test(e) || !mi.test(e) || r != null && e in Object(r);
}
var Qr = xi;
function wi(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var Ne = wi;
const Oi = /* @__PURE__ */ be(Ne);
var Si = Qe, Ci = Ne, Ei = "[object AsyncFunction]", Ti = "[object Function]", Ai = "[object GeneratorFunction]", ji = "[object Proxy]";
function Pi(e) {
  if (!Ci(e))
    return !1;
  var r = Si(e);
  return r == Ti || r == Ai || r == Ei || r == ji;
}
var Sn = Pi, Ri = Ee, Ii = Ri["__core-js_shared__"], Mi = Ii, Ar = Mi, At = function() {
  var e = /[^.]+$/.exec(Ar && Ar.keys && Ar.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ni(e) {
  return !!At && At in e;
}
var Fi = Ni, Di = Function.prototype, Li = Di.toString;
function Ui(e) {
  if (e != null) {
    try {
      return Li.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Cn = Ui, zi = Sn, Bi = Fi, ki = Ne, Hi = Cn, Gi = /[\\^$.*+?()[\]{}|]/g, Wi = /^\[object .+?Constructor\]$/, Vi = Function.prototype, qi = Object.prototype, Yi = Vi.toString, Ki = qi.hasOwnProperty, Zi = RegExp(
  "^" + Yi.call(Ki).replace(Gi, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ji(e) {
  if (!ki(e) || Bi(e))
    return !1;
  var r = zi(e) ? Zi : Wi;
  return r.test(Hi(e));
}
var Xi = Ji;
function Qi(e, r) {
  return e == null ? void 0 : e[r];
}
var es = Qi, rs = Xi, ts = es;
function ns(e, r) {
  var t = ts(e, r);
  return rs(t) ? t : void 0;
}
var Fe = ns, as = Fe, is = as(Object, "create"), vr = is, jt = vr;
function ss() {
  this.__data__ = jt ? jt(null) : {}, this.size = 0;
}
var os = ss;
function us(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var ls = us, cs = vr, fs = "__lodash_hash_undefined__", ds = Object.prototype, hs = ds.hasOwnProperty;
function ps(e) {
  var r = this.__data__;
  if (cs) {
    var t = r[e];
    return t === fs ? void 0 : t;
  }
  return hs.call(r, e) ? r[e] : void 0;
}
var gs = ps, vs = vr, _s = Object.prototype, bs = _s.hasOwnProperty;
function ys(e) {
  var r = this.__data__;
  return vs ? r[e] !== void 0 : bs.call(r, e);
}
var ms = ys, $s = vr, xs = "__lodash_hash_undefined__";
function ws(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = $s && r === void 0 ? xs : r, this;
}
var Os = ws, Ss = os, Cs = ls, Es = gs, Ts = ms, As = Os;
function Be(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Be.prototype.clear = Ss;
Be.prototype.delete = Cs;
Be.prototype.get = Es;
Be.prototype.has = Ts;
Be.prototype.set = As;
var js = Be;
function Ps() {
  this.__data__ = [], this.size = 0;
}
var Rs = Ps;
function Is(e, r) {
  return e === r || e !== e && r !== r;
}
var _r = Is, Ms = _r;
function Ns(e, r) {
  for (var t = e.length; t--; )
    if (Ms(e[t][0], r))
      return t;
  return -1;
}
var br = Ns, Fs = br, Ds = Array.prototype, Ls = Ds.splice;
function Us(e) {
  var r = this.__data__, t = Fs(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : Ls.call(r, t, 1), --this.size, !0;
}
var zs = Us, Bs = br;
function ks(e) {
  var r = this.__data__, t = Bs(r, e);
  return t < 0 ? void 0 : r[t][1];
}
var Hs = ks, Gs = br;
function Ws(e) {
  return Gs(this.__data__, e) > -1;
}
var Vs = Ws, qs = br;
function Ys(e, r) {
  var t = this.__data__, n = qs(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
var Ks = Ys, Zs = Rs, Js = zs, Xs = Hs, Qs = Vs, eo = Ks;
function ke(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
ke.prototype.clear = Zs;
ke.prototype.delete = Js;
ke.prototype.get = Xs;
ke.prototype.has = Qs;
ke.prototype.set = eo;
var yr = ke, ro = Fe, to = Ee, no = ro(to, "Map"), et = no, Pt = js, ao = yr, io = et;
function so() {
  this.size = 0, this.__data__ = {
    hash: new Pt(),
    map: new (io || ao)(),
    string: new Pt()
  };
}
var oo = so;
function uo(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
var lo = uo, co = lo;
function fo(e, r) {
  var t = e.__data__;
  return co(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
var mr = fo, ho = mr;
function po(e) {
  var r = ho(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
var go = po, vo = mr;
function _o(e) {
  return vo(this, e).get(e);
}
var bo = _o, yo = mr;
function mo(e) {
  return yo(this, e).has(e);
}
var $o = mo, xo = mr;
function wo(e, r) {
  var t = xo(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
var Oo = wo, So = oo, Co = go, Eo = bo, To = $o, Ao = Oo;
function He(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
He.prototype.clear = So;
He.prototype.delete = Co;
He.prototype.get = Eo;
He.prototype.has = To;
He.prototype.set = Ao;
var rt = He, En = rt, jo = "Expected a function";
function tt(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(jo);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], o = t.cache;
    if (o.has(a))
      return o.get(a);
    var d = e.apply(this, n);
    return t.cache = o.set(a, d) || o, d;
  };
  return t.cache = new (tt.Cache || En)(), t;
}
tt.Cache = En;
var Po = tt, Ro = Po, Io = 500;
function Mo(e) {
  var r = Ro(e, function(n) {
    return t.size === Io && t.clear(), n;
  }), t = r.cache;
  return r;
}
var No = Mo, Fo = No, Do = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Lo = /\\(\\)?/g, Uo = Fo(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(Do, function(t, n, a, o) {
    r.push(a ? o.replace(Lo, "$1") : n || t);
  }), r;
}), zo = Uo;
function Bo(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var Tn = Bo, Rt = Xe, ko = Tn, Ho = xe, Go = rr, Wo = 1 / 0, It = Rt ? Rt.prototype : void 0, Mt = It ? It.toString : void 0;
function An(e) {
  if (typeof e == "string")
    return e;
  if (Ho(e))
    return ko(e, An) + "";
  if (Go(e))
    return Mt ? Mt.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -Wo ? "-0" : r;
}
var Vo = An, qo = Vo;
function Yo(e) {
  return e == null ? "" : qo(e);
}
var Ge = Yo, Ko = xe, Zo = Qr, Jo = zo, Xo = Ge;
function Qo(e, r) {
  return Ko(e) ? e : Zo(e, r) ? [e] : Jo(Xo(e));
}
var nt = Qo, e1 = rr, r1 = 1 / 0;
function t1(e) {
  if (typeof e == "string" || e1(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -r1 ? "-0" : r;
}
var tr = t1, n1 = nt, a1 = tr;
function i1(e, r) {
  r = n1(r, e);
  for (var t = 0, n = r.length; e != null && t < n; )
    e = e[a1(r[t++])];
  return t && t == n ? e : void 0;
}
var at = i1, s1 = at;
function o1(e, r, t) {
  var n = e == null ? void 0 : s1(e, r);
  return n === void 0 ? t : n;
}
var jn = o1;
const Br = /* @__PURE__ */ be(jn);
var u1 = Object.prototype, l1 = u1.hasOwnProperty;
function c1(e, r) {
  return e != null && l1.call(e, r);
}
var f1 = c1, d1 = Qe, h1 = er, p1 = "[object Arguments]";
function g1(e) {
  return h1(e) && d1(e) == p1;
}
var v1 = g1, Nt = v1, _1 = er, Pn = Object.prototype, b1 = Pn.hasOwnProperty, y1 = Pn.propertyIsEnumerable, m1 = Nt(/* @__PURE__ */ function() {
  return arguments;
}()) ? Nt : function(e) {
  return _1(e) && b1.call(e, "callee") && !y1.call(e, "callee");
}, it = m1, $1 = 9007199254740991, x1 = /^(?:0|[1-9]\d*)$/;
function w1(e, r) {
  var t = typeof e;
  return r = r ?? $1, !!r && (t == "number" || t != "symbol" && x1.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var $r = w1, O1 = 9007199254740991;
function S1(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= O1;
}
var st = S1, C1 = nt, E1 = it, T1 = xe, A1 = $r, j1 = st, P1 = tr;
function R1(e, r, t) {
  r = C1(r, e);
  for (var n = -1, a = r.length, o = !1; ++n < a; ) {
    var d = P1(r[n]);
    if (!(o = e != null && t(e, d)))
      break;
    e = e[d];
  }
  return o || ++n != a ? o : (a = e == null ? 0 : e.length, !!a && j1(a) && A1(d, a) && (T1(e) || E1(e)));
}
var Rn = R1, I1 = f1, M1 = Rn;
function N1(e, r) {
  return e != null && M1(e, r, I1);
}
var F1 = N1;
const D1 = /* @__PURE__ */ be(F1);
var L1 = Fe, U1 = function() {
  try {
    var e = L1(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), In = U1, Ft = In;
function z1(e, r, t) {
  r == "__proto__" && Ft ? Ft(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
var B1 = z1, k1 = B1, H1 = _r, G1 = Object.prototype, W1 = G1.hasOwnProperty;
function V1(e, r, t) {
  var n = e[r];
  (!(W1.call(e, r) && H1(n, t)) || t === void 0 && !(r in e)) && k1(e, r, t);
}
var Mn = V1, q1 = Mn, Y1 = nt, K1 = $r, Dt = Ne, Z1 = tr;
function J1(e, r, t, n) {
  if (!Dt(e))
    return e;
  r = Y1(r, e);
  for (var a = -1, o = r.length, d = o - 1, b = e; b != null && ++a < o; ) {
    var m = Z1(r[a]), x = t;
    if (m === "__proto__" || m === "constructor" || m === "prototype")
      return e;
    if (a != d) {
      var C = b[m];
      x = n ? n(C, m, b) : void 0, x === void 0 && (x = Dt(C) ? C : K1(r[a + 1]) ? [] : {});
    }
    q1(b, m, x), b = b[m];
  }
  return e;
}
var Nn = J1, X1 = Nn;
function Q1(e, r, t) {
  return e == null ? e : X1(e, r, t);
}
var e0 = Q1;
const r0 = /* @__PURE__ */ be(e0);
var t0 = Nn;
function n0(e, r, t, n) {
  return n = typeof n == "function" ? n : void 0, e == null ? e : t0(e, r, t, n);
}
var a0 = n0;
const i0 = /* @__PURE__ */ be(a0);
var s0 = "__lodash_hash_undefined__";
function o0(e) {
  return this.__data__.set(e, s0), this;
}
var u0 = o0;
function l0(e) {
  return this.__data__.has(e);
}
var c0 = l0, f0 = rt, d0 = u0, h0 = c0;
function fr(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new f0(); ++r < t; )
    this.add(e[r]);
}
fr.prototype.add = fr.prototype.push = d0;
fr.prototype.has = h0;
var Fn = fr;
function p0(e, r, t, n) {
  for (var a = e.length, o = t + (n ? 1 : -1); n ? o-- : ++o < a; )
    if (r(e[o], o, e))
      return o;
  return -1;
}
var g0 = p0;
function v0(e) {
  return e !== e;
}
var _0 = v0;
function b0(e, r, t) {
  for (var n = t - 1, a = e.length; ++n < a; )
    if (e[n] === r)
      return n;
  return -1;
}
var y0 = b0, m0 = g0, $0 = _0, x0 = y0;
function w0(e, r, t) {
  return r === r ? x0(e, r, t) : m0(e, $0, t);
}
var O0 = w0, S0 = O0;
function C0(e, r) {
  var t = e == null ? 0 : e.length;
  return !!t && S0(e, r, 0) > -1;
}
var E0 = C0;
function T0(e, r, t) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
    if (t(r, e[n]))
      return !0;
  return !1;
}
var A0 = T0;
function j0(e, r) {
  return e.has(r);
}
var Dn = j0, P0 = Fe, R0 = Ee, I0 = P0(R0, "Set"), Ln = I0;
function M0() {
}
var N0 = M0;
function F0(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n) {
    t[++r] = n;
  }), t;
}
var ot = F0, jr = Ln, D0 = N0, L0 = ot, U0 = 1 / 0, z0 = jr && 1 / L0(new jr([, -0]))[1] == U0 ? function(e) {
  return new jr(e);
} : D0, B0 = z0, k0 = Fn, H0 = E0, G0 = A0, W0 = Dn, V0 = B0, q0 = ot, Y0 = 200;
function K0(e, r, t) {
  var n = -1, a = H0, o = e.length, d = !0, b = [], m = b;
  if (t)
    d = !1, a = G0;
  else if (o >= Y0) {
    var x = r ? null : V0(e);
    if (x)
      return q0(x);
    d = !1, a = W0, m = new k0();
  } else
    m = r ? [] : b;
  e:
    for (; ++n < o; ) {
      var C = e[n], E = r ? r(C) : C;
      if (C = t || C !== 0 ? C : 0, d && E === E) {
        for (var T = m.length; T--; )
          if (m[T] === E)
            continue e;
        r && m.push(E), b.push(C);
      } else
        a(m, E, t) || (m !== b && m.push(E), b.push(C));
    }
  return b;
}
var Z0 = K0, J0 = Z0;
function X0(e) {
  return e && e.length ? J0(e) : [];
}
var Q0 = X0;
const eu = /* @__PURE__ */ be(Q0), ru = (e, r) => {
  const t = [], n = [];
  return t.push(r), r || t.push(e.locale), e.enableFallback && t.push(e.defaultLocale), t.filter(Boolean).map((a) => a.toString()).forEach(function(a) {
    if (n.includes(a) || n.push(a), !e.enableFallback)
      return;
    const o = a.split("-");
    o.length === 3 && n.push(`${o[0]}-${o[1]}`), n.push(o[0]);
  }), eu(n);
};
class tu {
  constructor(r) {
    this.i18n = r, this.registry = {}, this.register("default", ru);
  }
  register(r, t) {
    if (typeof t != "function") {
      const n = t;
      t = () => n;
    }
    this.registry[r] = t;
  }
  get(r) {
    let t = this.registry[r] || this.registry[this.i18n.locale] || this.registry.default;
    return typeof t == "function" && (t = t(this.i18n, r)), t instanceof Array || (t = [t]), t;
  }
}
const nu = (e, r) => {
  const t = String(e).split("."), n = !t[1], a = Number(t[0]) == e, o = a && t[0].slice(-1), d = a && t[0].slice(-2);
  return r ? o == 1 && d != 11 ? "one" : o == 2 && d != 12 ? "two" : o == 3 && d != 13 ? "few" : "other" : e == 1 && n ? "one" : "other";
};
function au({ pluralizer: e, includeZero: r = !0, ordinal: t = !1 }) {
  return function(n, a) {
    return [
      r && a === 0 ? "zero" : "",
      e(a, t)
    ].filter(Boolean);
  };
}
const iu = au({
  pluralizer: nu,
  includeZero: !0
});
class su {
  constructor(r) {
    this.i18n = r, this.registry = {}, this.register("default", iu);
  }
  register(r, t) {
    this.registry[r] = t;
  }
  get(r) {
    return this.registry[r] || this.registry[this.i18n.locale] || this.registry.default;
  }
}
function ou(e, r, t) {
  var n = -1, a = e.length;
  r < 0 && (r = -r > a ? 0 : a + r), t = t > a ? a : t, t < 0 && (t += a), a = r > t ? 0 : t - r >>> 0, r >>>= 0;
  for (var o = Array(a); ++n < a; )
    o[n] = e[n + r];
  return o;
}
var uu = ou, lu = uu;
function cu(e, r, t) {
  var n = e.length;
  return t = t === void 0 ? n : t, !r && t >= n ? e : lu(e, r, t);
}
var fu = cu, du = "\\ud800-\\udfff", hu = "\\u0300-\\u036f", pu = "\\ufe20-\\ufe2f", gu = "\\u20d0-\\u20ff", vu = hu + pu + gu, _u = "\\ufe0e\\ufe0f", bu = "\\u200d", yu = RegExp("[" + bu + du + vu + _u + "]");
function mu(e) {
  return yu.test(e);
}
var Un = mu;
function $u(e) {
  return e.split("");
}
var xu = $u, zn = "\\ud800-\\udfff", wu = "\\u0300-\\u036f", Ou = "\\ufe20-\\ufe2f", Su = "\\u20d0-\\u20ff", Cu = wu + Ou + Su, Eu = "\\ufe0e\\ufe0f", Tu = "[" + zn + "]", kr = "[" + Cu + "]", Hr = "\\ud83c[\\udffb-\\udfff]", Au = "(?:" + kr + "|" + Hr + ")", Bn = "[^" + zn + "]", kn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Hn = "[\\ud800-\\udbff][\\udc00-\\udfff]", ju = "\\u200d", Gn = Au + "?", Wn = "[" + Eu + "]?", Pu = "(?:" + ju + "(?:" + [Bn, kn, Hn].join("|") + ")" + Wn + Gn + ")*", Ru = Wn + Gn + Pu, Iu = "(?:" + [Bn + kr + "?", kr, kn, Hn, Tu].join("|") + ")", Mu = RegExp(Hr + "(?=" + Hr + ")|" + Iu + Ru, "g");
function Nu(e) {
  return e.match(Mu) || [];
}
var Fu = Nu, Du = xu, Lu = Un, Uu = Fu;
function zu(e) {
  return Lu(e) ? Uu(e) : Du(e);
}
var Bu = zu, ku = fu, Hu = Un, Gu = Bu, Wu = Ge;
function Vu(e) {
  return function(r) {
    r = Wu(r);
    var t = Hu(r) ? Gu(r) : void 0, n = t ? t[0] : r.charAt(0), a = t ? ku(t, 1).join("") : r.slice(1);
    return n[e]() + a;
  };
}
var qu = Vu, Yu = qu, Ku = Yu("toUpperCase"), Zu = Ku, Ju = Ge, Xu = Zu;
function Qu(e) {
  return Xu(Ju(e).toLowerCase());
}
var el = Qu;
function rl(e, r, t, n) {
  var a = -1, o = e == null ? 0 : e.length;
  for (n && o && (t = e[++a]); ++a < o; )
    t = r(t, e[a], a, e);
  return t;
}
var tl = rl;
function nl(e) {
  return function(r) {
    return e == null ? void 0 : e[r];
  };
}
var al = nl, il = al, sl = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, ol = il(sl), ul = ol, ll = ul, cl = Ge, fl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, dl = "\\u0300-\\u036f", hl = "\\ufe20-\\ufe2f", pl = "\\u20d0-\\u20ff", gl = dl + hl + pl, vl = "[" + gl + "]", _l = RegExp(vl, "g");
function bl(e) {
  return e = cl(e), e && e.replace(fl, ll).replace(_l, "");
}
var yl = bl, ml = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function $l(e) {
  return e.match(ml) || [];
}
var xl = $l, wl = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Ol(e) {
  return wl.test(e);
}
var Sl = Ol, Vn = "\\ud800-\\udfff", Cl = "\\u0300-\\u036f", El = "\\ufe20-\\ufe2f", Tl = "\\u20d0-\\u20ff", Al = Cl + El + Tl, qn = "\\u2700-\\u27bf", Yn = "a-z\\xdf-\\xf6\\xf8-\\xff", jl = "\\xac\\xb1\\xd7\\xf7", Pl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Rl = "\\u2000-\\u206f", Il = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Kn = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ml = "\\ufe0e\\ufe0f", Zn = jl + Pl + Rl + Il, Jn = "['’]", Lt = "[" + Zn + "]", Nl = "[" + Al + "]", Xn = "\\d+", Fl = "[" + qn + "]", Qn = "[" + Yn + "]", ea = "[^" + Vn + Zn + Xn + qn + Yn + Kn + "]", Dl = "\\ud83c[\\udffb-\\udfff]", Ll = "(?:" + Nl + "|" + Dl + ")", Ul = "[^" + Vn + "]", ra = "(?:\\ud83c[\\udde6-\\uddff]){2}", ta = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ue = "[" + Kn + "]", zl = "\\u200d", Ut = "(?:" + Qn + "|" + ea + ")", Bl = "(?:" + Ue + "|" + ea + ")", zt = "(?:" + Jn + "(?:d|ll|m|re|s|t|ve))?", Bt = "(?:" + Jn + "(?:D|LL|M|RE|S|T|VE))?", na = Ll + "?", aa = "[" + Ml + "]?", kl = "(?:" + zl + "(?:" + [Ul, ra, ta].join("|") + ")" + aa + na + ")*", Hl = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Gl = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Wl = aa + na + kl, Vl = "(?:" + [Fl, ra, ta].join("|") + ")" + Wl, ql = RegExp([
  Ue + "?" + Qn + "+" + zt + "(?=" + [Lt, Ue, "$"].join("|") + ")",
  Bl + "+" + Bt + "(?=" + [Lt, Ue + Ut, "$"].join("|") + ")",
  Ue + "?" + Ut + "+" + zt,
  Ue + "+" + Bt,
  Gl,
  Hl,
  Xn,
  Vl
].join("|"), "g");
function Yl(e) {
  return e.match(ql) || [];
}
var Kl = Yl, Zl = xl, Jl = Sl, Xl = Ge, Ql = Kl;
function ec(e, r, t) {
  return e = Xl(e), r = t ? void 0 : r, r === void 0 ? Jl(e) ? Ql(e) : Zl(e) : e.match(r) || [];
}
var rc = ec, tc = tl, nc = yl, ac = rc, ic = "['’]", sc = RegExp(ic, "g");
function oc(e) {
  return function(r) {
    return tc(ac(nc(r).replace(sc, "")), e, "");
  };
}
var uc = oc, lc = el, cc = uc, fc = cc(function(e, r, t) {
  return r = r.toLowerCase(), e + (t ? lc(r) : r);
}), dc = fc;
const hc = /* @__PURE__ */ be(dc);
function me(e) {
  return e ? Object.keys(e).reduce((r, t) => (r[hc(t)] = e[t], r), {}) : {};
}
function Ce(e) {
  return e != null;
}
function pc(e, r, t) {
  let n = [{ scope: r }];
  if (Ce(t.defaults) && (n = n.concat(t.defaults)), Ce(t.defaultValue)) {
    const a = typeof t.defaultValue == "function" ? t.defaultValue(e, r, t) : t.defaultValue;
    n.push({ message: a }), delete t.defaultValue;
  }
  return n;
}
var gc = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Pr = Math.ceil, ge = Math.floor, ce = "[BigNumber Error] ", kt = ce + "Number primitive has more than 15 significant digits: ", ye = 1e14, M = 14, Rr = 9007199254740991, Ir = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], je = 1e7, re = 1e9;
function ia(e) {
  var r, t, n, a = $.prototype = { constructor: $, toString: null, valueOf: null }, o = new $(1), d = 20, b = 4, m = -7, x = 21, C = -1e7, E = 1e7, T = !1, R = 1, N = 0, k = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, H = "0123456789abcdefghijklmnopqrstuvwxyz", V = !0;
  function $(i, s) {
    var l, v, f, h, y, c, p, _, g = this;
    if (!(g instanceof $))
      return new $(i, s);
    if (s == null) {
      if (i && i._isBigNumber === !0) {
        g.s = i.s, !i.c || i.e > E ? g.c = g.e = null : i.e < C ? g.c = [g.e = 0] : (g.e = i.e, g.c = i.c.slice());
        return;
      }
      if ((c = typeof i == "number") && i * 0 == 0) {
        if (g.s = 1 / i < 0 ? (i = -i, -1) : 1, i === ~~i) {
          for (h = 0, y = i; y >= 10; y /= 10, h++)
            ;
          h > E ? g.c = g.e = null : (g.e = h, g.c = [i]);
          return;
        }
        _ = String(i);
      } else {
        if (!gc.test(_ = String(i)))
          return n(g, _, c);
        g.s = _.charCodeAt(0) == 45 ? (_ = _.slice(1), -1) : 1;
      }
      (h = _.indexOf(".")) > -1 && (_ = _.replace(".", "")), (y = _.search(/e/i)) > 0 ? (h < 0 && (h = y), h += +_.slice(y + 1), _ = _.substring(0, y)) : h < 0 && (h = _.length);
    } else {
      if (K(s, 2, H.length, "Base"), s == 10 && V)
        return g = new $(i), te(g, d + g.e + 1, b);
      if (_ = String(i), c = typeof i == "number") {
        if (i * 0 != 0)
          return n(g, _, c, s);
        if (g.s = 1 / i < 0 ? (_ = _.slice(1), -1) : 1, $.DEBUG && _.replace(/^0\.0*|\./, "").length > 15)
          throw Error(kt + i);
      } else
        g.s = _.charCodeAt(0) === 45 ? (_ = _.slice(1), -1) : 1;
      for (l = H.slice(0, s), h = y = 0, p = _.length; y < p; y++)
        if (l.indexOf(v = _.charAt(y)) < 0) {
          if (v == ".") {
            if (y > h) {
              h = p;
              continue;
            }
          } else if (!f && (_ == _.toUpperCase() && (_ = _.toLowerCase()) || _ == _.toLowerCase() && (_ = _.toUpperCase()))) {
            f = !0, y = -1, h = 0;
            continue;
          }
          return n(g, String(i), c, s);
        }
      c = !1, _ = t(_, s, 10, g.s), (h = _.indexOf(".")) > -1 ? _ = _.replace(".", "") : h = _.length;
    }
    for (y = 0; _.charCodeAt(y) === 48; y++)
      ;
    for (p = _.length; _.charCodeAt(--p) === 48; )
      ;
    if (_ = _.slice(y, ++p)) {
      if (p -= y, c && $.DEBUG && p > 15 && (i > Rr || i !== ge(i)))
        throw Error(kt + g.s * i);
      if ((h = h - y - 1) > E)
        g.c = g.e = null;
      else if (h < C)
        g.c = [g.e = 0];
      else {
        if (g.e = h, g.c = [], y = (h + 1) % M, h < 0 && (y += M), y < p) {
          for (y && g.c.push(+_.slice(0, y)), p -= M; y < p; )
            g.c.push(+_.slice(y, y += M));
          y = M - (_ = _.slice(y)).length;
        } else
          y -= p;
        for (; y--; _ += "0")
          ;
        g.c.push(+_);
      }
    } else
      g.c = [g.e = 0];
  }
  $.clone = ia, $.ROUND_UP = 0, $.ROUND_DOWN = 1, $.ROUND_CEIL = 2, $.ROUND_FLOOR = 3, $.ROUND_HALF_UP = 4, $.ROUND_HALF_DOWN = 5, $.ROUND_HALF_EVEN = 6, $.ROUND_HALF_CEIL = 7, $.ROUND_HALF_FLOOR = 8, $.EUCLID = 9, $.config = $.set = function(i) {
    var s, l;
    if (i != null)
      if (typeof i == "object") {
        if (i.hasOwnProperty(s = "DECIMAL_PLACES") && (l = i[s], K(l, 0, re, s), d = l), i.hasOwnProperty(s = "ROUNDING_MODE") && (l = i[s], K(l, 0, 8, s), b = l), i.hasOwnProperty(s = "EXPONENTIAL_AT") && (l = i[s], l && l.pop ? (K(l[0], -re, 0, s), K(l[1], 0, re, s), m = l[0], x = l[1]) : (K(l, -re, re, s), m = -(x = l < 0 ? -l : l))), i.hasOwnProperty(s = "RANGE"))
          if (l = i[s], l && l.pop)
            K(l[0], -re, -1, s), K(l[1], 1, re, s), C = l[0], E = l[1];
          else if (K(l, -re, re, s), l)
            C = -(E = l < 0 ? -l : l);
          else
            throw Error(ce + s + " cannot be zero: " + l);
        if (i.hasOwnProperty(s = "CRYPTO"))
          if (l = i[s], l === !!l)
            if (l)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                T = l;
              else
                throw T = !l, Error(ce + "crypto unavailable");
            else
              T = l;
          else
            throw Error(ce + s + " not true or false: " + l);
        if (i.hasOwnProperty(s = "MODULO_MODE") && (l = i[s], K(l, 0, 9, s), R = l), i.hasOwnProperty(s = "POW_PRECISION") && (l = i[s], K(l, 0, re, s), N = l), i.hasOwnProperty(s = "FORMAT"))
          if (l = i[s], typeof l == "object")
            k = l;
          else
            throw Error(ce + s + " not an object: " + l);
        if (i.hasOwnProperty(s = "ALPHABET"))
          if (l = i[s], typeof l == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(l))
            V = l.slice(0, 10) == "0123456789", H = l;
          else
            throw Error(ce + s + " invalid: " + l);
      } else
        throw Error(ce + "Object expected: " + i);
    return {
      DECIMAL_PLACES: d,
      ROUNDING_MODE: b,
      EXPONENTIAL_AT: [m, x],
      RANGE: [C, E],
      CRYPTO: T,
      MODULO_MODE: R,
      POW_PRECISION: N,
      FORMAT: k,
      ALPHABET: H
    };
  }, $.isBigNumber = function(i) {
    if (!i || i._isBigNumber !== !0)
      return !1;
    if (!$.DEBUG)
      return !0;
    var s, l, v = i.c, f = i.e, h = i.s;
    e:
      if ({}.toString.call(v) == "[object Array]") {
        if ((h === 1 || h === -1) && f >= -re && f <= re && f === ge(f)) {
          if (v[0] === 0) {
            if (f === 0 && v.length === 1)
              return !0;
            break e;
          }
          if (s = (f + 1) % M, s < 1 && (s += M), String(v[0]).length == s) {
            for (s = 0; s < v.length; s++)
              if (l = v[s], l < 0 || l >= ye || l !== ge(l))
                break e;
            if (l !== 0)
              return !0;
          }
        }
      } else if (v === null && f === null && (h === null || h === 1 || h === -1))
        return !0;
    throw Error(ce + "Invalid BigNumber: " + i);
  }, $.maximum = $.max = function() {
    return ue(arguments, -1);
  }, $.minimum = $.min = function() {
    return ue(arguments, 1);
  }, $.random = function() {
    var i = 9007199254740992, s = Math.random() * i & 2097151 ? function() {
      return ge(Math.random() * i);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(l) {
      var v, f, h, y, c, p = 0, _ = [], g = new $(o);
      if (l == null ? l = d : K(l, 0, re), y = Pr(l / M), T)
        if (crypto.getRandomValues) {
          for (v = crypto.getRandomValues(new Uint32Array(y *= 2)); p < y; )
            c = v[p] * 131072 + (v[p + 1] >>> 11), c >= 9e15 ? (f = crypto.getRandomValues(new Uint32Array(2)), v[p] = f[0], v[p + 1] = f[1]) : (_.push(c % 1e14), p += 2);
          p = y / 2;
        } else if (crypto.randomBytes) {
          for (v = crypto.randomBytes(y *= 7); p < y; )
            c = (v[p] & 31) * 281474976710656 + v[p + 1] * 1099511627776 + v[p + 2] * 4294967296 + v[p + 3] * 16777216 + (v[p + 4] << 16) + (v[p + 5] << 8) + v[p + 6], c >= 9e15 ? crypto.randomBytes(7).copy(v, p) : (_.push(c % 1e14), p += 7);
          p = y / 7;
        } else
          throw T = !1, Error(ce + "crypto unavailable");
      if (!T)
        for (; p < y; )
          c = s(), c < 9e15 && (_[p++] = c % 1e14);
      for (y = _[--p], l %= M, y && l && (c = Ir[M - l], _[p] = ge(y / c) * c); _[p] === 0; _.pop(), p--)
        ;
      if (p < 0)
        _ = [h = 0];
      else {
        for (h = -1; _[0] === 0; _.splice(0, 1), h -= M)
          ;
        for (p = 1, c = _[0]; c >= 10; c /= 10, p++)
          ;
        p < M && (h -= M - p);
      }
      return g.e = h, g.c = _, g;
    };
  }(), $.sum = function() {
    for (var i = 1, s = arguments, l = new $(s[0]); i < s.length; )
      l = l.plus(s[i++]);
    return l;
  }, t = /* @__PURE__ */ function() {
    var i = "0123456789";
    function s(l, v, f, h) {
      for (var y, c = [0], p, _ = 0, g = l.length; _ < g; ) {
        for (p = c.length; p--; c[p] *= v)
          ;
        for (c[0] += h.indexOf(l.charAt(_++)), y = 0; y < c.length; y++)
          c[y] > f - 1 && (c[y + 1] == null && (c[y + 1] = 0), c[y + 1] += c[y] / f | 0, c[y] %= f);
      }
      return c.reverse();
    }
    return function(l, v, f, h, y) {
      var c, p, _, g, w, j, P, D, q = l.indexOf("."), J = d, L = b;
      for (q >= 0 && (g = N, N = 0, l = l.replace(".", ""), D = new $(v), j = D.pow(l.length - q), N = g, D.c = s(
        Se(pe(j.c), j.e, "0"),
        10,
        f,
        i
      ), D.e = D.c.length), P = s(l, v, f, y ? (c = H, i) : (c = i, H)), _ = g = P.length; P[--g] == 0; P.pop())
        ;
      if (!P[0])
        return c.charAt(0);
      if (q < 0 ? --_ : (j.c = P, j.e = _, j.s = h, j = r(j, D, J, L, f), P = j.c, w = j.r, _ = j.e), p = _ + J + 1, q = P[p], g = f / 2, w = w || p < 0 || P[p + 1] != null, w = L < 4 ? (q != null || w) && (L == 0 || L == (j.s < 0 ? 3 : 2)) : q > g || q == g && (L == 4 || w || L == 6 && P[p - 1] & 1 || L == (j.s < 0 ? 8 : 7)), p < 1 || !P[0])
        l = w ? Se(c.charAt(1), -J, c.charAt(0)) : c.charAt(0);
      else {
        if (P.length = p, w)
          for (--f; ++P[--p] > f; )
            P[p] = 0, p || (++_, P = [1].concat(P));
        for (g = P.length; !P[--g]; )
          ;
        for (q = 0, l = ""; q <= g; l += c.charAt(P[q++]))
          ;
        l = Se(l, _, c.charAt(0));
      }
      return l;
    };
  }(), r = /* @__PURE__ */ function() {
    function i(v, f, h) {
      var y, c, p, _, g = 0, w = v.length, j = f % je, P = f / je | 0;
      for (v = v.slice(); w--; )
        p = v[w] % je, _ = v[w] / je | 0, y = P * p + _ * j, c = j * p + y % je * je + g, g = (c / h | 0) + (y / je | 0) + P * _, v[w] = c % h;
      return g && (v = [g].concat(v)), v;
    }
    function s(v, f, h, y) {
      var c, p;
      if (h != y)
        p = h > y ? 1 : -1;
      else
        for (c = p = 0; c < h; c++)
          if (v[c] != f[c]) {
            p = v[c] > f[c] ? 1 : -1;
            break;
          }
      return p;
    }
    function l(v, f, h, y) {
      for (var c = 0; h--; )
        v[h] -= c, c = v[h] < f[h] ? 1 : 0, v[h] = c * y + v[h] - f[h];
      for (; !v[0] && v.length > 1; v.splice(0, 1))
        ;
    }
    return function(v, f, h, y, c) {
      var p, _, g, w, j, P, D, q, J, L, z, Q, we, Pe, Te, de, Ae, le = v.s == f.s ? 1 : -1, ne = v.c, G = f.c;
      if (!ne || !ne[0] || !G || !G[0])
        return new $(
          // Return NaN if either NaN, or both Infinity or 0.
          !v.s || !f.s || (ne ? G && ne[0] == G[0] : !G) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            ne && ne[0] == 0 || !G ? le * 0 : le / 0
          )
        );
      for (q = new $(le), J = q.c = [], _ = v.e - f.e, le = h + _ + 1, c || (c = ye, _ = ve(v.e / M) - ve(f.e / M), le = le / M | 0), g = 0; G[g] == (ne[g] || 0); g++)
        ;
      if (G[g] > (ne[g] || 0) && _--, le < 0)
        J.push(1), w = !0;
      else {
        for (Pe = ne.length, de = G.length, g = 0, le += 2, j = ge(c / (G[0] + 1)), j > 1 && (G = i(G, j, c), ne = i(ne, j, c), de = G.length, Pe = ne.length), we = de, L = ne.slice(0, de), z = L.length; z < de; L[z++] = 0)
          ;
        Ae = G.slice(), Ae = [0].concat(Ae), Te = G[0], G[1] >= c / 2 && Te++;
        do {
          if (j = 0, p = s(G, L, de, z), p < 0) {
            if (Q = L[0], de != z && (Q = Q * c + (L[1] || 0)), j = ge(Q / Te), j > 1)
              for (j >= c && (j = c - 1), P = i(G, j, c), D = P.length, z = L.length; s(P, L, D, z) == 1; )
                j--, l(P, de < D ? Ae : G, D, c), D = P.length, p = 1;
            else
              j == 0 && (p = j = 1), P = G.slice(), D = P.length;
            if (D < z && (P = [0].concat(P)), l(L, P, z, c), z = L.length, p == -1)
              for (; s(G, L, de, z) < 1; )
                j++, l(L, de < z ? Ae : G, z, c), z = L.length;
          } else
            p === 0 && (j++, L = [0]);
          J[g++] = j, L[0] ? L[z++] = ne[we] || 0 : (L = [ne[we]], z = 1);
        } while ((we++ < Pe || L[0] != null) && le--);
        w = L[0] != null, J[0] || J.splice(0, 1);
      }
      if (c == ye) {
        for (g = 1, le = J[0]; le >= 10; le /= 10, g++)
          ;
        te(q, h + (q.e = g + _ * M - 1) + 1, y, w);
      } else
        q.e = _, q.r = +w;
      return q;
    };
  }();
  function oe(i, s, l, v) {
    var f, h, y, c, p;
    if (l == null ? l = b : K(l, 0, 8), !i.c)
      return i.toString();
    if (f = i.c[0], y = i.e, s == null)
      p = pe(i.c), p = v == 1 || v == 2 && (y <= m || y >= x) ? or(p, y) : Se(p, y, "0");
    else if (i = te(new $(i), s, l), h = i.e, p = pe(i.c), c = p.length, v == 1 || v == 2 && (s <= h || h <= m)) {
      for (; c < s; p += "0", c++)
        ;
      p = or(p, h);
    } else if (s -= y, p = Se(p, h, "0"), h + 1 > c) {
      if (--s > 0)
        for (p += "."; s--; p += "0")
          ;
    } else if (s += h - c, s > 0)
      for (h + 1 == c && (p += "."); s--; p += "0")
        ;
    return i.s < 0 && f ? "-" + p : p;
  }
  function ue(i, s) {
    for (var l, v, f = 1, h = new $(i[0]); f < i.length; f++)
      v = new $(i[f]), (!v.s || (l = Re(h, v)) === s || l === 0 && h.s === s) && (h = v);
    return h;
  }
  function ae(i, s, l) {
    for (var v = 1, f = s.length; !s[--f]; s.pop())
      ;
    for (f = s[0]; f >= 10; f /= 10, v++)
      ;
    return (l = v + l * M - 1) > E ? i.c = i.e = null : l < C ? i.c = [i.e = 0] : (i.e = l, i.c = s), i;
  }
  n = /* @__PURE__ */ function() {
    var i = /^(-?)0([xbo])(?=\w[\w.]*$)/i, s = /^([^.]+)\.$/, l = /^\.([^.]+)$/, v = /^-?(Infinity|NaN)$/, f = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(h, y, c, p) {
      var _, g = c ? y : y.replace(f, "");
      if (v.test(g))
        h.s = isNaN(g) ? null : g < 0 ? -1 : 1;
      else {
        if (!c && (g = g.replace(i, function(w, j, P) {
          return _ = (P = P.toLowerCase()) == "x" ? 16 : P == "b" ? 2 : 8, !p || p == _ ? j : w;
        }), p && (_ = p, g = g.replace(s, "$1").replace(l, "0.$1")), y != g))
          return new $(g, _);
        if ($.DEBUG)
          throw Error(ce + "Not a" + (p ? " base " + p : "") + " number: " + y);
        h.s = null;
      }
      h.c = h.e = null;
    };
  }();
  function te(i, s, l, v) {
    var f, h, y, c, p, _, g, w = i.c, j = Ir;
    if (w) {
      e: {
        for (f = 1, c = w[0]; c >= 10; c /= 10, f++)
          ;
        if (h = s - f, h < 0)
          h += M, y = s, p = w[_ = 0], g = ge(p / j[f - y - 1] % 10);
        else if (_ = Pr((h + 1) / M), _ >= w.length)
          if (v) {
            for (; w.length <= _; w.push(0))
              ;
            p = g = 0, f = 1, h %= M, y = h - M + 1;
          } else
            break e;
        else {
          for (p = c = w[_], f = 1; c >= 10; c /= 10, f++)
            ;
          h %= M, y = h - M + f, g = y < 0 ? 0 : ge(p / j[f - y - 1] % 10);
        }
        if (v = v || s < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        w[_ + 1] != null || (y < 0 ? p : p % j[f - y - 1]), v = l < 4 ? (g || v) && (l == 0 || l == (i.s < 0 ? 3 : 2)) : g > 5 || g == 5 && (l == 4 || v || l == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (h > 0 ? y > 0 ? p / j[f - y] : 0 : w[_ - 1]) % 10 & 1 || l == (i.s < 0 ? 8 : 7)), s < 1 || !w[0])
          return w.length = 0, v ? (s -= i.e + 1, w[0] = j[(M - s % M) % M], i.e = -s || 0) : w[0] = i.e = 0, i;
        if (h == 0 ? (w.length = _, c = 1, _--) : (w.length = _ + 1, c = j[M - h], w[_] = y > 0 ? ge(p / j[f - y] % j[y]) * c : 0), v)
          for (; ; )
            if (_ == 0) {
              for (h = 1, y = w[0]; y >= 10; y /= 10, h++)
                ;
              for (y = w[0] += c, c = 1; y >= 10; y /= 10, c++)
                ;
              h != c && (i.e++, w[0] == ye && (w[0] = 1));
              break;
            } else {
              if (w[_] += c, w[_] != ye)
                break;
              w[_--] = 0, c = 1;
            }
        for (h = w.length; w[--h] === 0; w.pop())
          ;
      }
      i.e > E ? i.c = i.e = null : i.e < C && (i.c = [i.e = 0]);
    }
    return i;
  }
  function ie(i) {
    var s, l = i.e;
    return l === null ? i.toString() : (s = pe(i.c), s = l <= m || l >= x ? or(s, l) : Se(s, l, "0"), i.s < 0 ? "-" + s : s);
  }
  return a.absoluteValue = a.abs = function() {
    var i = new $(this);
    return i.s < 0 && (i.s = 1), i;
  }, a.comparedTo = function(i, s) {
    return Re(this, new $(i, s));
  }, a.decimalPlaces = a.dp = function(i, s) {
    var l, v, f, h = this;
    if (i != null)
      return K(i, 0, re), s == null ? s = b : K(s, 0, 8), te(new $(h), i + h.e + 1, s);
    if (!(l = h.c))
      return null;
    if (v = ((f = l.length - 1) - ve(this.e / M)) * M, f = l[f])
      for (; f % 10 == 0; f /= 10, v--)
        ;
    return v < 0 && (v = 0), v;
  }, a.dividedBy = a.div = function(i, s) {
    return r(this, new $(i, s), d, b);
  }, a.dividedToIntegerBy = a.idiv = function(i, s) {
    return r(this, new $(i, s), 0, 1);
  }, a.exponentiatedBy = a.pow = function(i, s) {
    var l, v, f, h, y, c, p, _, g, w = this;
    if (i = new $(i), i.c && !i.isInteger())
      throw Error(ce + "Exponent not an integer: " + ie(i));
    if (s != null && (s = new $(s)), c = i.e > 14, !w.c || !w.c[0] || w.c[0] == 1 && !w.e && w.c.length == 1 || !i.c || !i.c[0])
      return g = new $(Math.pow(+ie(w), c ? i.s * (2 - sr(i)) : +ie(i))), s ? g.mod(s) : g;
    if (p = i.s < 0, s) {
      if (s.c ? !s.c[0] : !s.s)
        return new $(NaN);
      v = !p && w.isInteger() && s.isInteger(), v && (w = w.mod(s));
    } else {
      if (i.e > 9 && (w.e > 0 || w.e < -1 || (w.e == 0 ? w.c[0] > 1 || c && w.c[1] >= 24e7 : w.c[0] < 8e13 || c && w.c[0] <= 9999975e7)))
        return h = w.s < 0 && sr(i) ? -0 : 0, w.e > -1 && (h = 1 / h), new $(p ? 1 / h : h);
      N && (h = Pr(N / M + 2));
    }
    for (c ? (l = new $(0.5), p && (i.s = 1), _ = sr(i)) : (f = Math.abs(+ie(i)), _ = f % 2), g = new $(o); ; ) {
      if (_) {
        if (g = g.times(w), !g.c)
          break;
        h ? g.c.length > h && (g.c.length = h) : v && (g = g.mod(s));
      }
      if (f) {
        if (f = ge(f / 2), f === 0)
          break;
        _ = f % 2;
      } else if (i = i.times(l), te(i, i.e + 1, 1), i.e > 14)
        _ = sr(i);
      else {
        if (f = +ie(i), f === 0)
          break;
        _ = f % 2;
      }
      w = w.times(w), h ? w.c && w.c.length > h && (w.c.length = h) : v && (w = w.mod(s));
    }
    return v ? g : (p && (g = o.div(g)), s ? g.mod(s) : h ? te(g, N, b, y) : g);
  }, a.integerValue = function(i) {
    var s = new $(this);
    return i == null ? i = b : K(i, 0, 8), te(s, s.e + 1, i);
  }, a.isEqualTo = a.eq = function(i, s) {
    return Re(this, new $(i, s)) === 0;
  }, a.isFinite = function() {
    return !!this.c;
  }, a.isGreaterThan = a.gt = function(i, s) {
    return Re(this, new $(i, s)) > 0;
  }, a.isGreaterThanOrEqualTo = a.gte = function(i, s) {
    return (s = Re(this, new $(i, s))) === 1 || s === 0;
  }, a.isInteger = function() {
    return !!this.c && ve(this.e / M) > this.c.length - 2;
  }, a.isLessThan = a.lt = function(i, s) {
    return Re(this, new $(i, s)) < 0;
  }, a.isLessThanOrEqualTo = a.lte = function(i, s) {
    return (s = Re(this, new $(i, s))) === -1 || s === 0;
  }, a.isNaN = function() {
    return !this.s;
  }, a.isNegative = function() {
    return this.s < 0;
  }, a.isPositive = function() {
    return this.s > 0;
  }, a.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, a.minus = function(i, s) {
    var l, v, f, h, y = this, c = y.s;
    if (i = new $(i, s), s = i.s, !c || !s)
      return new $(NaN);
    if (c != s)
      return i.s = -s, y.plus(i);
    var p = y.e / M, _ = i.e / M, g = y.c, w = i.c;
    if (!p || !_) {
      if (!g || !w)
        return g ? (i.s = -s, i) : new $(w ? y : NaN);
      if (!g[0] || !w[0])
        return w[0] ? (i.s = -s, i) : new $(g[0] ? y : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          b == 3 ? -0 : 0
        ));
    }
    if (p = ve(p), _ = ve(_), g = g.slice(), c = p - _) {
      for ((h = c < 0) ? (c = -c, f = g) : (_ = p, f = w), f.reverse(), s = c; s--; f.push(0))
        ;
      f.reverse();
    } else
      for (v = (h = (c = g.length) < (s = w.length)) ? c : s, c = s = 0; s < v; s++)
        if (g[s] != w[s]) {
          h = g[s] < w[s];
          break;
        }
    if (h && (f = g, g = w, w = f, i.s = -i.s), s = (v = w.length) - (l = g.length), s > 0)
      for (; s--; g[l++] = 0)
        ;
    for (s = ye - 1; v > c; ) {
      if (g[--v] < w[v]) {
        for (l = v; l && !g[--l]; g[l] = s)
          ;
        --g[l], g[v] += ye;
      }
      g[v] -= w[v];
    }
    for (; g[0] == 0; g.splice(0, 1), --_)
      ;
    return g[0] ? ae(i, g, _) : (i.s = b == 3 ? -1 : 1, i.c = [i.e = 0], i);
  }, a.modulo = a.mod = function(i, s) {
    var l, v, f = this;
    return i = new $(i, s), !f.c || !i.s || i.c && !i.c[0] ? new $(NaN) : !i.c || f.c && !f.c[0] ? new $(f) : (R == 9 ? (v = i.s, i.s = 1, l = r(f, i, 0, 3), i.s = v, l.s *= v) : l = r(f, i, 0, R), i = f.minus(l.times(i)), !i.c[0] && R == 1 && (i.s = f.s), i);
  }, a.multipliedBy = a.times = function(i, s) {
    var l, v, f, h, y, c, p, _, g, w, j, P, D, q, J, L = this, z = L.c, Q = (i = new $(i, s)).c;
    if (!z || !Q || !z[0] || !Q[0])
      return !L.s || !i.s || z && !z[0] && !Q || Q && !Q[0] && !z ? i.c = i.e = i.s = null : (i.s *= L.s, !z || !Q ? i.c = i.e = null : (i.c = [0], i.e = 0)), i;
    for (v = ve(L.e / M) + ve(i.e / M), i.s *= L.s, p = z.length, w = Q.length, p < w && (D = z, z = Q, Q = D, f = p, p = w, w = f), f = p + w, D = []; f--; D.push(0))
      ;
    for (q = ye, J = je, f = w; --f >= 0; ) {
      for (l = 0, j = Q[f] % J, P = Q[f] / J | 0, y = p, h = f + y; h > f; )
        _ = z[--y] % J, g = z[y] / J | 0, c = P * _ + g * j, _ = j * _ + c % J * J + D[h] + l, l = (_ / q | 0) + (c / J | 0) + P * g, D[h--] = _ % q;
      D[h] = l;
    }
    return l ? ++v : D.splice(0, 1), ae(i, D, v);
  }, a.negated = function() {
    var i = new $(this);
    return i.s = -i.s || null, i;
  }, a.plus = function(i, s) {
    var l, v = this, f = v.s;
    if (i = new $(i, s), s = i.s, !f || !s)
      return new $(NaN);
    if (f != s)
      return i.s = -s, v.minus(i);
    var h = v.e / M, y = i.e / M, c = v.c, p = i.c;
    if (!h || !y) {
      if (!c || !p)
        return new $(f / 0);
      if (!c[0] || !p[0])
        return p[0] ? i : new $(c[0] ? v : f * 0);
    }
    if (h = ve(h), y = ve(y), c = c.slice(), f = h - y) {
      for (f > 0 ? (y = h, l = p) : (f = -f, l = c), l.reverse(); f--; l.push(0))
        ;
      l.reverse();
    }
    for (f = c.length, s = p.length, f - s < 0 && (l = p, p = c, c = l, s = f), f = 0; s; )
      f = (c[--s] = c[s] + p[s] + f) / ye | 0, c[s] = ye === c[s] ? 0 : c[s] % ye;
    return f && (c = [f].concat(c), ++y), ae(i, c, y);
  }, a.precision = a.sd = function(i, s) {
    var l, v, f, h = this;
    if (i != null && i !== !!i)
      return K(i, 1, re), s == null ? s = b : K(s, 0, 8), te(new $(h), i, s);
    if (!(l = h.c))
      return null;
    if (f = l.length - 1, v = f * M + 1, f = l[f]) {
      for (; f % 10 == 0; f /= 10, v--)
        ;
      for (f = l[0]; f >= 10; f /= 10, v++)
        ;
    }
    return i && h.e + 1 > v && (v = h.e + 1), v;
  }, a.shiftedBy = function(i) {
    return K(i, -Rr, Rr), this.times("1e" + i);
  }, a.squareRoot = a.sqrt = function() {
    var i, s, l, v, f, h = this, y = h.c, c = h.s, p = h.e, _ = d + 4, g = new $("0.5");
    if (c !== 1 || !y || !y[0])
      return new $(!c || c < 0 && (!y || y[0]) ? NaN : y ? h : 1 / 0);
    if (c = Math.sqrt(+ie(h)), c == 0 || c == 1 / 0 ? (s = pe(y), (s.length + p) % 2 == 0 && (s += "0"), c = Math.sqrt(+s), p = ve((p + 1) / 2) - (p < 0 || p % 2), c == 1 / 0 ? s = "5e" + p : (s = c.toExponential(), s = s.slice(0, s.indexOf("e") + 1) + p), l = new $(s)) : l = new $(c + ""), l.c[0]) {
      for (p = l.e, c = p + _, c < 3 && (c = 0); ; )
        if (f = l, l = g.times(f.plus(r(h, f, _, 1))), pe(f.c).slice(0, c) === (s = pe(l.c)).slice(0, c))
          if (l.e < p && --c, s = s.slice(c - 3, c + 1), s == "9999" || !v && s == "4999") {
            if (!v && (te(f, f.e + d + 2, 0), f.times(f).eq(h))) {
              l = f;
              break;
            }
            _ += 4, c += 4, v = 1;
          } else {
            (!+s || !+s.slice(1) && s.charAt(0) == "5") && (te(l, l.e + d + 2, 1), i = !l.times(l).eq(h));
            break;
          }
    }
    return te(l, l.e + d + 1, b, i);
  }, a.toExponential = function(i, s) {
    return i != null && (K(i, 0, re), i++), oe(this, i, s, 1);
  }, a.toFixed = function(i, s) {
    return i != null && (K(i, 0, re), i = i + this.e + 1), oe(this, i, s);
  }, a.toFormat = function(i, s, l) {
    var v, f = this;
    if (l == null)
      i != null && s && typeof s == "object" ? (l = s, s = null) : i && typeof i == "object" ? (l = i, i = s = null) : l = k;
    else if (typeof l != "object")
      throw Error(ce + "Argument not an object: " + l);
    if (v = f.toFixed(i, s), f.c) {
      var h, y = v.split("."), c = +l.groupSize, p = +l.secondaryGroupSize, _ = l.groupSeparator || "", g = y[0], w = y[1], j = f.s < 0, P = j ? g.slice(1) : g, D = P.length;
      if (p && (h = c, c = p, p = h, D -= h), c > 0 && D > 0) {
        for (h = D % c || c, g = P.substr(0, h); h < D; h += c)
          g += _ + P.substr(h, c);
        p > 0 && (g += _ + P.slice(h)), j && (g = "-" + g);
      }
      v = w ? g + (l.decimalSeparator || "") + ((p = +l.fractionGroupSize) ? w.replace(
        new RegExp("\\d{" + p + "}\\B", "g"),
        "$&" + (l.fractionGroupSeparator || "")
      ) : w) : g;
    }
    return (l.prefix || "") + v + (l.suffix || "");
  }, a.toFraction = function(i) {
    var s, l, v, f, h, y, c, p, _, g, w, j, P = this, D = P.c;
    if (i != null && (c = new $(i), !c.isInteger() && (c.c || c.s !== 1) || c.lt(o)))
      throw Error(ce + "Argument " + (c.isInteger() ? "out of range: " : "not an integer: ") + ie(c));
    if (!D)
      return new $(P);
    for (s = new $(o), _ = l = new $(o), v = p = new $(o), j = pe(D), h = s.e = j.length - P.e - 1, s.c[0] = Ir[(y = h % M) < 0 ? M + y : y], i = !i || c.comparedTo(s) > 0 ? h > 0 ? s : _ : c, y = E, E = 1 / 0, c = new $(j), p.c[0] = 0; g = r(c, s, 0, 1), f = l.plus(g.times(v)), f.comparedTo(i) != 1; )
      l = v, v = f, _ = p.plus(g.times(f = _)), p = f, s = c.minus(g.times(f = s)), c = f;
    return f = r(i.minus(l), v, 0, 1), p = p.plus(f.times(_)), l = l.plus(f.times(v)), p.s = _.s = P.s, h = h * 2, w = r(_, v, h, b).minus(P).abs().comparedTo(
      r(p, l, h, b).minus(P).abs()
    ) < 1 ? [_, v] : [p, l], E = y, w;
  }, a.toNumber = function() {
    return +ie(this);
  }, a.toPrecision = function(i, s) {
    return i != null && K(i, 1, re), oe(this, i, s, 2);
  }, a.toString = function(i) {
    var s, l = this, v = l.s, f = l.e;
    return f === null ? v ? (s = "Infinity", v < 0 && (s = "-" + s)) : s = "NaN" : (i == null ? s = f <= m || f >= x ? or(pe(l.c), f) : Se(pe(l.c), f, "0") : i === 10 && V ? (l = te(new $(l), d + f + 1, b), s = Se(pe(l.c), l.e, "0")) : (K(i, 2, H.length, "Base"), s = t(Se(pe(l.c), f, "0"), 10, i, v, !0)), v < 0 && l.c[0] && (s = "-" + s)), s;
  }, a.valueOf = a.toJSON = function() {
    return ie(this);
  }, a._isBigNumber = !0, a[Symbol.toStringTag] = "BigNumber", a[Symbol.for("nodejs.util.inspect.custom")] = a.valueOf, e != null && $.set(e), $;
}
function ve(e) {
  var r = e | 0;
  return e > 0 || e === r ? r : r - 1;
}
function pe(e) {
  for (var r, t, n = 1, a = e.length, o = e[0] + ""; n < a; ) {
    for (r = e[n++] + "", t = M - r.length; t--; r = "0" + r)
      ;
    o += r;
  }
  for (a = o.length; o.charCodeAt(--a) === 48; )
    ;
  return o.slice(0, a + 1 || 1);
}
function Re(e, r) {
  var t, n, a = e.c, o = r.c, d = e.s, b = r.s, m = e.e, x = r.e;
  if (!d || !b)
    return null;
  if (t = a && !a[0], n = o && !o[0], t || n)
    return t ? n ? 0 : -b : d;
  if (d != b)
    return d;
  if (t = d < 0, n = m == x, !a || !o)
    return n ? 0 : !a ^ t ? 1 : -1;
  if (!n)
    return m > x ^ t ? 1 : -1;
  for (b = (m = a.length) < (x = o.length) ? m : x, d = 0; d < b; d++)
    if (a[d] != o[d])
      return a[d] > o[d] ^ t ? 1 : -1;
  return m == x ? 0 : m > x ^ t ? 1 : -1;
}
function K(e, r, t, n) {
  if (e < r || e > t || e !== ge(e))
    throw Error(ce + (n || "Argument") + (typeof e == "number" ? e < r || e > t ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function sr(e) {
  var r = e.c.length - 1;
  return ve(e.e / M) == r && e.c[r] % 2 != 0;
}
function or(e, r) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (r < 0 ? "e" : "e+") + r;
}
function Se(e, r, t) {
  var n, a;
  if (r < 0) {
    for (a = t + "."; ++r; a += t)
      ;
    e = a + e;
  } else if (n = e.length, ++r > n) {
    for (a = t, r -= n; --r; a += t)
      ;
    e += a;
  } else
    r < n && (e = e.slice(0, r) + "." + e.slice(r));
  return e;
}
var Z = ia(), dr;
(function(e) {
  e[e.up = Z.ROUND_UP] = "up", e[e.down = Z.ROUND_DOWN] = "down", e[e.truncate = Z.ROUND_DOWN] = "truncate", e[e.halfUp = Z.ROUND_HALF_UP] = "halfUp", e[e.default = Z.ROUND_HALF_UP] = "default", e[e.halfDown = Z.ROUND_HALF_DOWN] = "halfDown", e[e.halfEven = Z.ROUND_HALF_EVEN] = "halfEven", e[e.banker = Z.ROUND_HALF_EVEN] = "banker", e[e.ceiling = Z.ROUND_CEIL] = "ceiling", e[e.ceil = Z.ROUND_CEIL] = "ceil", e[e.floor = Z.ROUND_FLOOR] = "floor";
})(dr || (dr = {}));
function sa(e) {
  var r;
  return (r = dr[e]) !== null && r !== void 0 ? r : dr.default;
}
var vc = 9007199254740991, _c = Math.floor;
function bc(e, r) {
  var t = "";
  if (!e || r < 1 || r > vc)
    return t;
  do
    r % 2 && (t += e), r = _c(r / 2), r && (e += e);
  while (r);
  return t;
}
var yc = bc, mc = Sn, $c = st;
function xc(e) {
  return e != null && $c(e.length) && !mc(e);
}
var xr = xc, wc = _r, Oc = xr, Sc = $r, Cc = Ne;
function Ec(e, r, t) {
  if (!Cc(t))
    return !1;
  var n = typeof r;
  return (n == "number" ? Oc(t) && Sc(r, t.length) : n == "string" && r in t) ? wc(t[r], e) : !1;
}
var ut = Ec, Tc = /\s/;
function Ac(e) {
  for (var r = e.length; r-- && Tc.test(e.charAt(r)); )
    ;
  return r;
}
var jc = Ac, Pc = jc, Rc = /^\s+/;
function Ic(e) {
  return e && e.slice(0, Pc(e) + 1).replace(Rc, "");
}
var Mc = Ic, Nc = Mc, Ht = Ne, Fc = rr, Gt = NaN, Dc = /^[-+]0x[0-9a-f]+$/i, Lc = /^0b[01]+$/i, Uc = /^0o[0-7]+$/i, zc = parseInt;
function Bc(e) {
  if (typeof e == "number")
    return e;
  if (Fc(e))
    return Gt;
  if (Ht(e)) {
    var r = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ht(r) ? r + "" : r;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Nc(e);
  var t = Lc.test(e);
  return t || Uc.test(e) ? zc(e.slice(2), t ? 2 : 8) : Dc.test(e) ? Gt : +e;
}
var kc = Bc, Hc = kc, Wt = 1 / 0, Gc = 17976931348623157e292;
function Wc(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Hc(e), e === Wt || e === -Wt) {
    var r = e < 0 ? -1 : 1;
    return r * Gc;
  }
  return e === e ? e : 0;
}
var oa = Wc, Vc = oa;
function qc(e) {
  var r = Vc(e), t = r % 1;
  return r === r ? t ? r - t : r : 0;
}
var Yc = qc, Kc = yc, Zc = ut, Jc = Yc, Xc = Ge;
function Qc(e, r, t) {
  return (t ? Zc(e, r, t) : r === void 0) ? r = 1 : r = Jc(r), Kc(Xc(e), r);
}
var ef = Qc;
const rf = /* @__PURE__ */ be(ef);
function tf(e) {
  return e.isZero() ? 1 : Math.floor(Math.log10(e.abs().toNumber()) + 1);
}
function nf(e, { precision: r, significant: t }) {
  return t && r !== null && r > 0 ? r - tf(e) : r;
}
function hr(e, r) {
  const t = nf(e, r);
  if (t === null)
    return e.toString();
  const n = sa(r.roundMode);
  if (t >= 0)
    return e.toFixed(t, n);
  const a = Math.pow(10, Math.abs(t));
  return e = new Z(e.div(a).toFixed(0, n)).times(a), e.toString();
}
function af(e, { formattedNumber: r, unit: t }) {
  return e.replace("%n", r).replace("%u", t);
}
function sf({ significand: e, whole: r, precision: t }) {
  if (r === "0" || t === null)
    return e;
  const n = Math.max(0, t - r.length);
  return (e ?? "").substr(0, n);
}
function Je(e, r) {
  var t, n, a;
  const o = new Z(e);
  if (r.raise && !o.isFinite())
    throw new Error(`"${e}" is not a valid numeric value`);
  const d = hr(o, r), b = new Z(d), m = b.lt(0), x = b.isZero();
  let [C, E] = d.split(".");
  const T = [];
  let R;
  const N = (t = r.format) !== null && t !== void 0 ? t : "%n", k = (n = r.negativeFormat) !== null && n !== void 0 ? n : `-${N}`, H = m && !x ? k : N;
  for (C = C.replace("-", ""); C.length > 0; )
    T.unshift(C.substr(Math.max(0, C.length - 3), 3)), C = C.substr(0, C.length - 3);
  return C = T.join(""), R = T.join(r.delimiter), r.significant ? E = sf({
    whole: C,
    significand: E,
    precision: r.precision
  }) : E = E ?? rf("0", (a = r.precision) !== null && a !== void 0 ? a : 0), r.stripInsignificantZeros && E && (E = E.replace(/0+$/, "")), o.isNaN() && (R = e.toString()), E && o.isFinite() && (R += (r.separator || ".") + E), af(H, {
    formattedNumber: R,
    unit: r.unit
  });
}
function ze(e, r, t) {
  let n = "";
  return (r instanceof String || typeof r == "string") && (n = r), r instanceof Array && (n = r.join(e.defaultSeparator)), t.scope && (n = [t.scope, n].join(e.defaultSeparator)), n;
}
function Me(e) {
  var r, t;
  if (e === null)
    return "null";
  const n = typeof e;
  return n !== "object" ? n : ((t = (r = e == null ? void 0 : e.constructor) === null || r === void 0 ? void 0 : r.name) === null || t === void 0 ? void 0 : t.toLowerCase()) || "object";
}
function Mr(e, r, t) {
  t = Object.keys(t).reduce((a, o) => (a[e.transformKey(o)] = t[o], a), {});
  const n = r.match(e.placeholder);
  if (!n)
    return r;
  for (; n.length; ) {
    let a;
    const o = n.shift(), d = o.replace(e.placeholder, "$1");
    Ce(t[d]) ? a = t[d].toString().replace(/\$/gm, "_#$#_") : d in t ? a = e.nullPlaceholder(e, o, r, t) : a = e.missingPlaceholder(e, o, r, t);
    const b = new RegExp(o.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
    r = r.replace(b, a);
  }
  return r.replace(/_#\$#_/g, "$");
}
function $e(e, r, t = {}) {
  t = Object.assign({}, t);
  const n = "locale" in t ? t.locale : e.locale, a = Me(n), o = e.locales.get(a === "string" ? n : typeof n).slice();
  r = ze(e, r, t).split(e.defaultSeparator).map((b) => e.transformKey(b)).join(".");
  const d = o.map((b) => Br(e.translations, [b, r].join(".")));
  return d.push(t.defaultValue), d.find((b) => Ce(b));
}
function of(e, r) {
  const t = new Z(e);
  if (!t.isFinite())
    return e.toString();
  if (!r.delimiterPattern.global)
    throw new Error(`options.delimiterPattern must be a global regular expression; received ${r.delimiterPattern}`);
  let [n, a] = t.toString().split(".");
  return n = n.replace(r.delimiterPattern, (o) => `${o}${r.delimiter}`), [n, a].filter(Boolean).join(r.separator);
}
function uf(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var ua = uf, Vt = Xe, lf = it, cf = xe, qt = Vt ? Vt.isConcatSpreadable : void 0;
function ff(e) {
  return cf(e) || lf(e) || !!(qt && e && e[qt]);
}
var df = ff, hf = ua, pf = df;
function la(e, r, t, n, a) {
  var o = -1, d = e.length;
  for (t || (t = pf), a || (a = []); ++o < d; ) {
    var b = e[o];
    r > 0 && t(b) ? r > 1 ? la(b, r - 1, t, n, a) : hf(a, b) : n || (a[a.length] = b);
  }
  return a;
}
var ca = la, gf = yr;
function vf() {
  this.__data__ = new gf(), this.size = 0;
}
var _f = vf;
function bf(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
var yf = bf;
function mf(e) {
  return this.__data__.get(e);
}
var $f = mf;
function xf(e) {
  return this.__data__.has(e);
}
var wf = xf, Of = yr, Sf = et, Cf = rt, Ef = 200;
function Tf(e, r) {
  var t = this.__data__;
  if (t instanceof Of) {
    var n = t.__data__;
    if (!Sf || n.length < Ef - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new Cf(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
var Af = Tf, jf = yr, Pf = _f, Rf = yf, If = $f, Mf = wf, Nf = Af;
function We(e) {
  var r = this.__data__ = new jf(e);
  this.size = r.size;
}
We.prototype.clear = Pf;
We.prototype.delete = Rf;
We.prototype.get = If;
We.prototype.has = Mf;
We.prototype.set = Nf;
var fa = We;
function Ff(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n; )
    if (r(e[t], t, e))
      return !0;
  return !1;
}
var Df = Ff, Lf = Fn, Uf = Df, zf = Dn, Bf = 1, kf = 2;
function Hf(e, r, t, n, a, o) {
  var d = t & Bf, b = e.length, m = r.length;
  if (b != m && !(d && m > b))
    return !1;
  var x = o.get(e), C = o.get(r);
  if (x && C)
    return x == r && C == e;
  var E = -1, T = !0, R = t & kf ? new Lf() : void 0;
  for (o.set(e, r), o.set(r, e); ++E < b; ) {
    var N = e[E], k = r[E];
    if (n)
      var H = d ? n(k, N, E, r, e, o) : n(N, k, E, e, r, o);
    if (H !== void 0) {
      if (H)
        continue;
      T = !1;
      break;
    }
    if (R) {
      if (!Uf(r, function(V, $) {
        if (!zf(R, $) && (N === V || a(N, V, t, n, o)))
          return R.push($);
      })) {
        T = !1;
        break;
      }
    } else if (!(N === k || a(N, k, t, n, o))) {
      T = !1;
      break;
    }
  }
  return o.delete(e), o.delete(r), T;
}
var da = Hf, Gf = Ee, Wf = Gf.Uint8Array, Vf = Wf;
function qf(e) {
  var r = -1, t = Array(e.size);
  return e.forEach(function(n, a) {
    t[++r] = [a, n];
  }), t;
}
var Yf = qf, Yt = Xe, Kt = Vf, Kf = _r, Zf = da, Jf = Yf, Xf = ot, Qf = 1, e2 = 2, r2 = "[object Boolean]", t2 = "[object Date]", n2 = "[object Error]", a2 = "[object Map]", i2 = "[object Number]", s2 = "[object RegExp]", o2 = "[object Set]", u2 = "[object String]", l2 = "[object Symbol]", c2 = "[object ArrayBuffer]", f2 = "[object DataView]", Zt = Yt ? Yt.prototype : void 0, Nr = Zt ? Zt.valueOf : void 0;
function d2(e, r, t, n, a, o, d) {
  switch (t) {
    case f2:
      if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset)
        return !1;
      e = e.buffer, r = r.buffer;
    case c2:
      return !(e.byteLength != r.byteLength || !o(new Kt(e), new Kt(r)));
    case r2:
    case t2:
    case i2:
      return Kf(+e, +r);
    case n2:
      return e.name == r.name && e.message == r.message;
    case s2:
    case u2:
      return e == r + "";
    case a2:
      var b = Jf;
    case o2:
      var m = n & Qf;
      if (b || (b = Xf), e.size != r.size && !m)
        return !1;
      var x = d.get(e);
      if (x)
        return x == r;
      n |= e2, d.set(e, r);
      var C = Zf(b(e), b(r), n, a, o, d);
      return d.delete(e), C;
    case l2:
      if (Nr)
        return Nr.call(e) == Nr.call(r);
  }
  return !1;
}
var h2 = d2, p2 = ua, g2 = xe;
function v2(e, r, t) {
  var n = r(e);
  return g2(e) ? n : p2(n, t(e));
}
var _2 = v2;
function b2(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, o = []; ++t < n; ) {
    var d = e[t];
    r(d, t, e) && (o[a++] = d);
  }
  return o;
}
var y2 = b2;
function m2() {
  return [];
}
var $2 = m2, x2 = y2, w2 = $2, O2 = Object.prototype, S2 = O2.propertyIsEnumerable, Jt = Object.getOwnPropertySymbols, C2 = Jt ? function(e) {
  return e == null ? [] : (e = Object(e), x2(Jt(e), function(r) {
    return S2.call(e, r);
  }));
} : w2, E2 = C2;
function T2(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var A2 = T2, pr = { exports: {} };
function j2() {
  return !1;
}
var P2 = j2;
pr.exports;
(function(e, r) {
  var t = Ee, n = P2, a = r && !r.nodeType && r, o = a && !0 && e && !e.nodeType && e, d = o && o.exports === a, b = d ? t.Buffer : void 0, m = b ? b.isBuffer : void 0, x = m || n;
  e.exports = x;
})(pr, pr.exports);
var ha = pr.exports, R2 = Qe, I2 = st, M2 = er, N2 = "[object Arguments]", F2 = "[object Array]", D2 = "[object Boolean]", L2 = "[object Date]", U2 = "[object Error]", z2 = "[object Function]", B2 = "[object Map]", k2 = "[object Number]", H2 = "[object Object]", G2 = "[object RegExp]", W2 = "[object Set]", V2 = "[object String]", q2 = "[object WeakMap]", Y2 = "[object ArrayBuffer]", K2 = "[object DataView]", Z2 = "[object Float32Array]", J2 = "[object Float64Array]", X2 = "[object Int8Array]", Q2 = "[object Int16Array]", e3 = "[object Int32Array]", r3 = "[object Uint8Array]", t3 = "[object Uint8ClampedArray]", n3 = "[object Uint16Array]", a3 = "[object Uint32Array]", Y = {};
Y[Z2] = Y[J2] = Y[X2] = Y[Q2] = Y[e3] = Y[r3] = Y[t3] = Y[n3] = Y[a3] = !0;
Y[N2] = Y[F2] = Y[Y2] = Y[D2] = Y[K2] = Y[L2] = Y[U2] = Y[z2] = Y[B2] = Y[k2] = Y[H2] = Y[G2] = Y[W2] = Y[V2] = Y[q2] = !1;
function i3(e) {
  return M2(e) && I2(e.length) && !!Y[R2(e)];
}
var s3 = i3;
function o3(e) {
  return function(r) {
    return e(r);
  };
}
var pa = o3, gr = { exports: {} };
gr.exports;
(function(e, r) {
  var t = wn, n = r && !r.nodeType && r, a = n && !0 && e && !e.nodeType && e, o = a && a.exports === n, d = o && t.process, b = function() {
    try {
      var m = a && a.require && a.require("util").types;
      return m || d && d.binding && d.binding("util");
    } catch {
    }
  }();
  e.exports = b;
})(gr, gr.exports);
var u3 = gr.exports, l3 = s3, c3 = pa, Xt = u3, Qt = Xt && Xt.isTypedArray, f3 = Qt ? c3(Qt) : l3, ga = f3, d3 = A2, h3 = it, p3 = xe, g3 = ha, v3 = $r, _3 = ga, b3 = Object.prototype, y3 = b3.hasOwnProperty;
function m3(e, r) {
  var t = p3(e), n = !t && h3(e), a = !t && !n && g3(e), o = !t && !n && !a && _3(e), d = t || n || a || o, b = d ? d3(e.length, String) : [], m = b.length;
  for (var x in e)
    (r || y3.call(e, x)) && !(d && // Safari 9 has enumerable `arguments.length` in strict mode.
    (x == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (x == "offset" || x == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (x == "buffer" || x == "byteLength" || x == "byteOffset") || // Skip index properties.
    v3(x, m))) && b.push(x);
  return b;
}
var $3 = m3, x3 = Object.prototype;
function w3(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || x3;
  return e === t;
}
var O3 = w3;
function S3(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var C3 = S3, E3 = C3, T3 = E3(Object.keys, Object), A3 = T3, j3 = O3, P3 = A3, R3 = Object.prototype, I3 = R3.hasOwnProperty;
function M3(e) {
  if (!j3(e))
    return P3(e);
  var r = [];
  for (var t in Object(e))
    I3.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
var N3 = M3, F3 = $3, D3 = N3, L3 = xr;
function U3(e) {
  return L3(e) ? F3(e) : D3(e);
}
var lt = U3, z3 = _2, B3 = E2, k3 = lt;
function H3(e) {
  return z3(e, k3, B3);
}
var G3 = H3, en = G3, W3 = 1, V3 = Object.prototype, q3 = V3.hasOwnProperty;
function Y3(e, r, t, n, a, o) {
  var d = t & W3, b = en(e), m = b.length, x = en(r), C = x.length;
  if (m != C && !d)
    return !1;
  for (var E = m; E--; ) {
    var T = b[E];
    if (!(d ? T in r : q3.call(r, T)))
      return !1;
  }
  var R = o.get(e), N = o.get(r);
  if (R && N)
    return R == r && N == e;
  var k = !0;
  o.set(e, r), o.set(r, e);
  for (var H = d; ++E < m; ) {
    T = b[E];
    var V = e[T], $ = r[T];
    if (n)
      var oe = d ? n($, V, T, r, e, o) : n(V, $, T, e, r, o);
    if (!(oe === void 0 ? V === $ || a(V, $, t, n, o) : oe)) {
      k = !1;
      break;
    }
    H || (H = T == "constructor");
  }
  if (k && !H) {
    var ue = e.constructor, ae = r.constructor;
    ue != ae && "constructor" in e && "constructor" in r && !(typeof ue == "function" && ue instanceof ue && typeof ae == "function" && ae instanceof ae) && (k = !1);
  }
  return o.delete(e), o.delete(r), k;
}
var K3 = Y3, Z3 = Fe, J3 = Ee, X3 = Z3(J3, "DataView"), Q3 = X3, ed = Fe, rd = Ee, td = ed(rd, "Promise"), nd = td, ad = Fe, id = Ee, sd = ad(id, "WeakMap"), od = sd, Gr = Q3, Wr = et, Vr = nd, qr = Ln, Yr = od, va = Qe, Ve = Cn, rn = "[object Map]", ud = "[object Object]", tn = "[object Promise]", nn = "[object Set]", an = "[object WeakMap]", sn = "[object DataView]", ld = Ve(Gr), cd = Ve(Wr), fd = Ve(Vr), dd = Ve(qr), hd = Ve(Yr), Ie = va;
(Gr && Ie(new Gr(new ArrayBuffer(1))) != sn || Wr && Ie(new Wr()) != rn || Vr && Ie(Vr.resolve()) != tn || qr && Ie(new qr()) != nn || Yr && Ie(new Yr()) != an) && (Ie = function(e) {
  var r = va(e), t = r == ud ? e.constructor : void 0, n = t ? Ve(t) : "";
  if (n)
    switch (n) {
      case ld:
        return sn;
      case cd:
        return rn;
      case fd:
        return tn;
      case dd:
        return nn;
      case hd:
        return an;
    }
  return r;
});
var pd = Ie, Fr = fa, gd = da, vd = h2, _d = K3, on = pd, un = xe, ln = ha, bd = ga, yd = 1, cn = "[object Arguments]", fn = "[object Array]", ur = "[object Object]", md = Object.prototype, dn = md.hasOwnProperty;
function $d(e, r, t, n, a, o) {
  var d = un(e), b = un(r), m = d ? fn : on(e), x = b ? fn : on(r);
  m = m == cn ? ur : m, x = x == cn ? ur : x;
  var C = m == ur, E = x == ur, T = m == x;
  if (T && ln(e)) {
    if (!ln(r))
      return !1;
    d = !0, C = !1;
  }
  if (T && !C)
    return o || (o = new Fr()), d || bd(e) ? gd(e, r, t, n, a, o) : vd(e, r, m, t, n, a, o);
  if (!(t & yd)) {
    var R = C && dn.call(e, "__wrapped__"), N = E && dn.call(r, "__wrapped__");
    if (R || N) {
      var k = R ? e.value() : e, H = N ? r.value() : r;
      return o || (o = new Fr()), a(k, H, t, n, o);
    }
  }
  return T ? (o || (o = new Fr()), _d(e, r, t, n, a, o)) : !1;
}
var xd = $d, wd = xd, hn = er;
function _a(e, r, t, n, a) {
  return e === r ? !0 : e == null || r == null || !hn(e) && !hn(r) ? e !== e && r !== r : wd(e, r, t, n, _a, a);
}
var ba = _a, Od = fa, Sd = ba, Cd = 1, Ed = 2;
function Td(e, r, t, n) {
  var a = t.length, o = a, d = !n;
  if (e == null)
    return !o;
  for (e = Object(e); a--; ) {
    var b = t[a];
    if (d && b[2] ? b[1] !== e[b[0]] : !(b[0] in e))
      return !1;
  }
  for (; ++a < o; ) {
    b = t[a];
    var m = b[0], x = e[m], C = b[1];
    if (d && b[2]) {
      if (x === void 0 && !(m in e))
        return !1;
    } else {
      var E = new Od();
      if (n)
        var T = n(x, C, m, e, r, E);
      if (!(T === void 0 ? Sd(C, x, Cd | Ed, n, E) : T))
        return !1;
    }
  }
  return !0;
}
var Ad = Td, jd = Ne;
function Pd(e) {
  return e === e && !jd(e);
}
var ya = Pd, Rd = ya, Id = lt;
function Md(e) {
  for (var r = Id(e), t = r.length; t--; ) {
    var n = r[t], a = e[n];
    r[t] = [n, a, Rd(a)];
  }
  return r;
}
var Nd = Md;
function Fd(e, r) {
  return function(t) {
    return t == null ? !1 : t[e] === r && (r !== void 0 || e in Object(t));
  };
}
var ma = Fd, Dd = Ad, Ld = Nd, Ud = ma;
function zd(e) {
  var r = Ld(e);
  return r.length == 1 && r[0][2] ? Ud(r[0][0], r[0][1]) : function(t) {
    return t === e || Dd(t, e, r);
  };
}
var Bd = zd;
function kd(e, r) {
  return e != null && r in Object(e);
}
var Hd = kd, Gd = Hd, Wd = Rn;
function Vd(e, r) {
  return e != null && Wd(e, r, Gd);
}
var qd = Vd, Yd = ba, Kd = jn, Zd = qd, Jd = Qr, Xd = ya, Qd = ma, eh = tr, rh = 1, th = 2;
function nh(e, r) {
  return Jd(e) && Xd(r) ? Qd(eh(e), r) : function(t) {
    var n = Kd(t, e);
    return n === void 0 && n === r ? Zd(t, e) : Yd(r, n, rh | th);
  };
}
var ah = nh;
function ih(e) {
  return e;
}
var wr = ih;
function sh(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var oh = sh, uh = at;
function lh(e) {
  return function(r) {
    return uh(r, e);
  };
}
var ch = lh, fh = oh, dh = ch, hh = Qr, ph = tr;
function gh(e) {
  return hh(e) ? fh(ph(e)) : dh(e);
}
var vh = gh, _h = Bd, bh = ah, yh = wr, mh = xe, $h = vh;
function xh(e) {
  return typeof e == "function" ? e : e == null ? yh : typeof e == "object" ? mh(e) ? bh(e[0], e[1]) : _h(e) : $h(e);
}
var wh = xh;
function Oh(e) {
  return function(r, t, n) {
    for (var a = -1, o = Object(r), d = n(r), b = d.length; b--; ) {
      var m = d[e ? b : ++a];
      if (t(o[m], m, o) === !1)
        break;
    }
    return r;
  };
}
var Sh = Oh, Ch = Sh, Eh = Ch(), Th = Eh, Ah = Th, jh = lt;
function Ph(e, r) {
  return e && Ah(e, r, jh);
}
var Rh = Ph, Ih = xr;
function Mh(e, r) {
  return function(t, n) {
    if (t == null)
      return t;
    if (!Ih(t))
      return e(t, n);
    for (var a = t.length, o = r ? a : -1, d = Object(t); (r ? o-- : ++o < a) && n(d[o], o, d) !== !1; )
      ;
    return t;
  };
}
var Nh = Mh, Fh = Rh, Dh = Nh, Lh = Dh(Fh), Uh = Lh, zh = Uh, Bh = xr;
function kh(e, r) {
  var t = -1, n = Bh(e) ? Array(e.length) : [];
  return zh(e, function(a, o, d) {
    n[++t] = r(a, o, d);
  }), n;
}
var Hh = kh;
function Gh(e, r) {
  var t = e.length;
  for (e.sort(r); t--; )
    e[t] = e[t].value;
  return e;
}
var Wh = Gh, pn = rr;
function Vh(e, r) {
  if (e !== r) {
    var t = e !== void 0, n = e === null, a = e === e, o = pn(e), d = r !== void 0, b = r === null, m = r === r, x = pn(r);
    if (!b && !x && !o && e > r || o && d && m && !b && !x || n && d && m || !t && m || !a)
      return 1;
    if (!n && !o && !x && e < r || x && t && a && !n && !o || b && t && a || !d && a || !m)
      return -1;
  }
  return 0;
}
var qh = Vh, Yh = qh;
function Kh(e, r, t) {
  for (var n = -1, a = e.criteria, o = r.criteria, d = a.length, b = t.length; ++n < d; ) {
    var m = Yh(a[n], o[n]);
    if (m) {
      if (n >= b)
        return m;
      var x = t[n];
      return m * (x == "desc" ? -1 : 1);
    }
  }
  return e.index - r.index;
}
var Zh = Kh, Dr = Tn, Jh = at, Xh = wh, Qh = Hh, e4 = Wh, r4 = pa, t4 = Zh, n4 = wr, a4 = xe;
function i4(e, r, t) {
  r.length ? r = Dr(r, function(o) {
    return a4(o) ? function(d) {
      return Jh(d, o.length === 1 ? o[0] : o);
    } : o;
  }) : r = [n4];
  var n = -1;
  r = Dr(r, r4(Xh));
  var a = Qh(e, function(o, d, b) {
    var m = Dr(r, function(x) {
      return x(o);
    });
    return { criteria: m, index: ++n, value: o };
  });
  return e4(a, function(o, d) {
    return t4(o, d, t);
  });
}
var s4 = i4;
function o4(e, r, t) {
  switch (t.length) {
    case 0:
      return e.call(r);
    case 1:
      return e.call(r, t[0]);
    case 2:
      return e.call(r, t[0], t[1]);
    case 3:
      return e.call(r, t[0], t[1], t[2]);
  }
  return e.apply(r, t);
}
var u4 = o4, l4 = u4, gn = Math.max;
function c4(e, r, t) {
  return r = gn(r === void 0 ? e.length - 1 : r, 0), function() {
    for (var n = arguments, a = -1, o = gn(n.length - r, 0), d = Array(o); ++a < o; )
      d[a] = n[r + a];
    a = -1;
    for (var b = Array(r + 1); ++a < r; )
      b[a] = n[a];
    return b[r] = t(d), l4(e, this, b);
  };
}
var f4 = c4;
function d4(e) {
  return function() {
    return e;
  };
}
var h4 = d4, p4 = h4, vn = In, g4 = wr, v4 = vn ? function(e, r) {
  return vn(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: p4(r),
    writable: !0
  });
} : g4, _4 = v4, b4 = 800, y4 = 16, m4 = Date.now;
function $4(e) {
  var r = 0, t = 0;
  return function() {
    var n = m4(), a = y4 - (n - t);
    if (t = n, a > 0) {
      if (++r >= b4)
        return arguments[0];
    } else
      r = 0;
    return e.apply(void 0, arguments);
  };
}
var x4 = $4, w4 = _4, O4 = x4, S4 = O4(w4), C4 = S4, E4 = wr, T4 = f4, A4 = C4;
function j4(e, r) {
  return A4(T4(e, r, E4), e + "");
}
var P4 = j4, R4 = ca, I4 = s4, M4 = P4, _n = ut, N4 = M4(function(e, r) {
  if (e == null)
    return [];
  var t = r.length;
  return t > 1 && _n(e, r[0], r[1]) ? r = [] : t > 2 && _n(r[0], r[1], r[2]) && (r = [r[0]]), I4(e, R4(r, 1), []);
}), F4 = N4;
const D4 = /* @__PURE__ */ be(F4);
function L4(e, r, t) {
  for (var n = -1, a = e.length, o = r.length, d = {}; ++n < a; ) {
    var b = n < o ? r[n] : void 0;
    t(d, e[n], b);
  }
  return d;
}
var U4 = L4, z4 = Mn, B4 = U4;
function k4(e, r) {
  return B4(e || [], r || [], z4);
}
var H4 = k4;
const G4 = /* @__PURE__ */ be(H4), Kr = {
  0: "unit",
  1: "ten",
  2: "hundred",
  3: "thousand",
  6: "million",
  9: "billion",
  12: "trillion",
  15: "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
}, W4 = G4(Object.values(Kr), Object.keys(Kr).map((e) => parseInt(e, 10)));
function V4(e, r, t) {
  const n = {
    roundMode: t.roundMode,
    precision: t.precision,
    significant: t.significant
  };
  let a;
  if (Me(t.units) === "string") {
    const E = t.units;
    if (a = $e(e, E), !a)
      throw new Error(`The scope "${e.locale}${e.defaultSeparator}${ze(e, E, {})}" couldn't be found`);
  } else
    a = t.units;
  let o = hr(new Z(r), n);
  const d = (E) => D4(Object.keys(E).map((T) => W4[T]), (T) => T * -1), b = (E, T) => {
    const R = E.isZero() ? 0 : Math.floor(Math.log10(E.abs().toNumber()));
    return d(T).find((N) => R >= N) || 0;
  }, m = (E, T) => {
    const R = Kr[T.toString()];
    return E[R] || "";
  }, x = b(new Z(o), a), C = m(a, x);
  if (o = hr(new Z(o).div(Math.pow(10, x)), n), t.stripInsignificantZeros) {
    let [E, T] = o.split(".");
    T = (T || "").replace(/0+$/, ""), o = E, T && (o += `${t.separator}${T}`);
  }
  return t.format.replace("%n", o || "0").replace("%u", C).trim();
}
const bn = ["byte", "kb", "mb", "gb", "tb", "pb", "eb"];
function q4(e, r, t) {
  const n = sa(t.roundMode), a = 1024, o = new Z(r).abs(), d = o.lt(a);
  let b;
  const m = (N, k) => {
    const H = k.length - 1, V = new Z(Math.log(N.toNumber())).div(Math.log(a)).integerValue(Z.ROUND_DOWN).toNumber();
    return Math.min(H, V);
  }, x = (N) => `number.human.storage_units.units.${d ? "byte" : N[C]}`, C = m(o, bn);
  d ? b = o.integerValue() : b = new Z(hr(o.div(Math.pow(a, C)), {
    significant: t.significant,
    precision: t.precision,
    roundMode: t.roundMode
  }));
  const E = e.translate("number.human.storage_units.format", {
    defaultValue: "%n %u"
  }), T = e.translate(x(bn), {
    count: o.integerValue().toNumber()
  });
  let R = b.toFixed(t.precision, n);
  return t.stripInsignificantZeros && (R = R.replace(/(\..*?)0+$/, "$1").replace(/\.$/, "")), E.replace("%n", R).replace("%u", T);
}
function Zr(e) {
  if (e instanceof Date)
    return e;
  if (typeof e == "number") {
    const n = /* @__PURE__ */ new Date();
    return n.setTime(e), n;
  }
  const r = new String(e).match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})(?:[.,](\d{1,3}))?)?(Z|\+00:?00)?/);
  if (r) {
    const n = r.slice(1, 8).map((T) => parseInt(T, 10) || 0);
    n[1] -= 1;
    const [a, o, d, b, m, x, C] = n;
    return r[8] ? new Date(Date.UTC(a, o, d, b, m, x, C)) : new Date(a, o, d, b, m, x, C);
  }
  e.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/) && (/* @__PURE__ */ new Date()).setTime(Date.parse([RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5].join(" ")));
  const t = /* @__PURE__ */ new Date();
  return t.setTime(Date.parse(e)), t;
}
function yn({ i18n: e, count: r, scope: t, options: n, baseScope: a }) {
  n = Object.assign({}, n);
  let o, d;
  if (typeof t == "object" && t ? o = t : o = $e(e, t, n), !o)
    return e.missingTranslation.get(t, n);
  const m = e.pluralization.get(n.locale)(e, r), x = [];
  for (; m.length; ) {
    const C = m.shift();
    if (Ce(o[C])) {
      d = o[C];
      break;
    }
    x.push(C);
  }
  return Ce(d) ? (n.count = r, e.interpolate(e, d, n)) : e.missingTranslation.get(a.split(e.defaultSeparator).concat([x[0]]), n);
}
var Y4 = ca, K4 = 1 / 0;
function Z4(e) {
  var r = e == null ? 0 : e.length;
  return r ? Y4(e, K4) : [];
}
var J4 = Z4;
const X4 = /* @__PURE__ */ be(J4);
class Q4 {
  constructor(r) {
    this.target = r;
  }
  call() {
    const r = X4(Object.keys(this.target).map((t) => this.compute(this.target[t], t)));
    return r.sort(), r;
  }
  compute(r, t) {
    return !Array.isArray(r) && Oi(r) ? Object.keys(r).map((n) => this.compute(r[n], `${t}.${n}`)) : t;
  }
}
function ep(e) {
  return new Q4(e).call();
}
const rp = {
  meridian: { am: "AM", pm: "PM" },
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  monthNames: [
    null,
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  abbrMonthNames: [
    null,
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};
function tp(e, r, t = {}) {
  const { abbrDayNames: n, dayNames: a, abbrMonthNames: o, monthNames: d, meridian: b } = Object.assign(Object.assign({}, rp), t);
  if (isNaN(e.getTime()))
    throw new Error("strftime() requires a valid date object, but received an invalid date.");
  const m = e.getDay(), x = e.getDate(), C = e.getFullYear(), E = e.getMonth() + 1, T = e.getHours();
  let R = T;
  const N = T > 11 ? "pm" : "am", k = e.getSeconds(), H = e.getMinutes(), V = e.getTimezoneOffset(), $ = Math.floor(Math.abs(V / 60)), oe = Math.abs(V) - $ * 60, ue = (V > 0 ? "-" : "+") + ($.toString().length < 2 ? "0" + $ : $) + (oe.toString().length < 2 ? "0" + oe : oe);
  return R > 12 ? R = R - 12 : R === 0 && (R = 12), r = r.replace("%a", n[m]), r = r.replace("%A", a[m]), r = r.replace("%b", o[E]), r = r.replace("%B", d[E]), r = r.replace("%d", x.toString().padStart(2, "0")), r = r.replace("%e", x.toString()), r = r.replace("%-d", x.toString()), r = r.replace("%H", T.toString().padStart(2, "0")), r = r.replace("%-H", T.toString()), r = r.replace("%k", T.toString()), r = r.replace("%I", R.toString().padStart(2, "0")), r = r.replace("%-I", R.toString()), r = r.replace("%l", R.toString()), r = r.replace("%m", E.toString().padStart(2, "0")), r = r.replace("%-m", E.toString()), r = r.replace("%M", H.toString().padStart(2, "0")), r = r.replace("%-M", H.toString()), r = r.replace("%p", b[N]), r = r.replace("%P", b[N].toLowerCase()), r = r.replace("%S", k.toString().padStart(2, "0")), r = r.replace("%-S", k.toString()), r = r.replace("%w", m.toString()), r = r.replace("%y", C.toString().padStart(2, "0").substr(-2)), r = r.replace("%-y", C.toString().padStart(2, "0").substr(-2).replace(/^0+/, "")), r = r.replace("%Y", C.toString()), r = r.replace(/%z/i, ue), r;
}
var np = Math.ceil, ap = Math.max;
function ip(e, r, t, n) {
  for (var a = -1, o = ap(np((r - e) / (t || 1)), 0), d = Array(o); o--; )
    d[n ? o : ++a] = e, e += t;
  return d;
}
var sp = ip, op = sp, up = ut, Lr = oa;
function lp(e) {
  return function(r, t, n) {
    return n && typeof n != "number" && up(r, t, n) && (t = n = void 0), r = Lr(r), t === void 0 ? (t = r, r = 0) : t = Lr(t), n = n === void 0 ? r < t ? 1 : -1 : Lr(n), op(r, t, n, e);
  };
}
var cp = lp, fp = cp, dp = fp(), hp = dp;
const pp = /* @__PURE__ */ be(hp), fe = (e, r, t) => t >= e && t <= r;
function gp(e, r, t, n = {}) {
  const a = n.scope || "datetime.distance_in_words", o = (ie, i = 0) => e.t(ie, { count: i, scope: a });
  r = Zr(r), t = Zr(t);
  let d = r.getTime() / 1e3, b = t.getTime() / 1e3;
  d > b && ([r, t, d, b] = [
    t,
    r,
    b,
    d
  ]);
  const m = Math.round(b - d), x = Math.round((b - d) / 60), E = x / 60 / 24, T = Math.round(x / 60), R = Math.round(E), N = Math.round(R / 30);
  if (fe(0, 1, x))
    return n.includeSeconds ? fe(0, 4, m) ? o("less_than_x_seconds", 5) : fe(5, 9, m) ? o("less_than_x_seconds", 10) : fe(10, 19, m) ? o("less_than_x_seconds", 20) : fe(20, 39, m) ? o("half_a_minute") : fe(40, 59, m) ? o("less_than_x_minutes", 1) : o("x_minutes", 1) : x === 0 ? o("less_than_x_minutes", 1) : o("x_minutes", x);
  if (fe(2, 44, x))
    return o("x_minutes", x);
  if (fe(45, 89, x))
    return o("about_x_hours", 1);
  if (fe(90, 1439, x))
    return o("about_x_hours", T);
  if (fe(1440, 2519, x))
    return o("x_days", 1);
  if (fe(2520, 43199, x))
    return o("x_days", R);
  if (fe(43200, 86399, x))
    return o("about_x_months", Math.round(x / 43200));
  if (fe(86400, 525599, x))
    return o("x_months", N);
  let k = r.getFullYear();
  r.getMonth() + 1 >= 3 && (k += 1);
  let H = t.getFullYear();
  t.getMonth() + 1 < 3 && (H -= 1);
  const V = k > H ? 0 : pp(k, H).filter((ie) => new Date(ie, 1, 29).getMonth() == 1).length, $ = 525600, oe = V * 1440, ue = x - oe, ae = Math.trunc(ue / $), te = parseFloat((ue / $ - ae).toPrecision(3));
  return te < 0.25 ? o("about_x_years", ae) : te < 0.75 ? o("over_x_years", ae) : o("almost_x_years", ae + 1);
}
const vp = function(e, r) {
  r instanceof Array && (r = r.join(e.defaultSeparator));
  const t = r.split(e.defaultSeparator).slice(-1)[0];
  return e.missingTranslationPrefix + t.replace("_", " ").replace(/([a-z])([A-Z])/g, (n, a, o) => `${a} ${o.toLowerCase()}`);
}, _p = (e, r, t) => {
  const n = ze(e, r, t), a = "locale" in t ? t.locale : e.locale, o = Me(a);
  return `[missing "${[
    o == "string" ? a : o,
    n
  ].join(e.defaultSeparator)}" translation]`;
}, bp = (e, r, t) => {
  const n = ze(e, r, t), a = [e.locale, n].join(e.defaultSeparator);
  throw new Error(`Missing translation: ${a}`);
};
class yp {
  constructor(r) {
    this.i18n = r, this.registry = {}, this.register("guess", vp), this.register("message", _p), this.register("error", bp);
  }
  register(r, t) {
    this.registry[r] = t;
  }
  get(r, t) {
    var n;
    return this.registry[(n = t.missingBehavior) !== null && n !== void 0 ? n : this.i18n.missingBehavior](this.i18n, r, t);
  }
}
var mp = function(e, r, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(d) {
      d(o);
    });
  }
  return new (t || (t = Promise))(function(o, d) {
    function b(C) {
      try {
        x(n.next(C));
      } catch (E) {
        d(E);
      }
    }
    function m(C) {
      try {
        x(n.throw(C));
      } catch (E) {
        d(E);
      }
    }
    function x(C) {
      C.done ? o(C.value) : a(C.value).then(b, m);
    }
    x((n = n.apply(e, r || [])).next());
  });
};
const Ur = {
  defaultLocale: "en",
  availableLocales: ["en"],
  locale: "en",
  defaultSeparator: ".",
  placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
  enableFallback: !1,
  missingBehavior: "message",
  missingTranslationPrefix: "",
  missingPlaceholder: (e, r) => `[missing "${r}" value]`,
  nullPlaceholder: (e, r, t, n) => e.missingPlaceholder(e, r, t, n),
  transformKey: (e) => e
};
class $a {
  constructor(r = {}, t = {}) {
    this._locale = Ur.locale, this._defaultLocale = Ur.defaultLocale, this._version = 0, this.onChangeHandlers = [], this.translations = {}, this.availableLocales = [], this.t = this.translate, this.p = this.pluralize, this.l = this.localize, this.distanceOfTimeInWords = this.timeAgoInWords;
    const { locale: n, enableFallback: a, missingBehavior: o, missingTranslationPrefix: d, missingPlaceholder: b, nullPlaceholder: m, defaultLocale: x, defaultSeparator: C, placeholder: E, transformKey: T } = Object.assign(Object.assign({}, Ur), t);
    this.locale = n, this.defaultLocale = x, this.defaultSeparator = C, this.enableFallback = a, this.locale = n, this.missingBehavior = o, this.missingTranslationPrefix = d, this.missingPlaceholder = b, this.nullPlaceholder = m, this.placeholder = E, this.pluralization = new su(this), this.locales = new tu(this), this.missingTranslation = new yp(this), this.transformKey = T, this.interpolate = Mr, this.store(r);
  }
  store(r) {
    ep(r).forEach((n) => i0(this.translations, n, Br(r, n), Object)), this.hasChanged();
  }
  get locale() {
    return this._locale || this.defaultLocale || "en";
  }
  set locale(r) {
    if (typeof r != "string")
      throw new Error(`Expected newLocale to be a string; got ${Me(r)}`);
    const t = this._locale !== r;
    this._locale = r, t && this.hasChanged();
  }
  get defaultLocale() {
    return this._defaultLocale || "en";
  }
  set defaultLocale(r) {
    if (typeof r != "string")
      throw new Error(`Expected newLocale to be a string; got ${Me(r)}`);
    const t = this._defaultLocale !== r;
    this._defaultLocale = r, t && this.hasChanged();
  }
  translate(r, t) {
    t = Object.assign({}, t);
    const n = pc(this, r, t);
    let a;
    return n.some((d) => (Ce(d.scope) ? a = $e(this, d.scope, t) : Ce(d.message) && (a = d.message), a != null)) ? (typeof a == "string" ? a = this.interpolate(this, a, t) : typeof a == "object" && a && Ce(t.count) && (a = yn({
      i18n: this,
      count: t.count || 0,
      scope: a,
      options: t,
      baseScope: ze(this, r, t)
    })), t && a instanceof Array && (a = a.map((d) => typeof d == "string" ? Mr(this, d, t) : d)), a) : this.missingTranslation.get(r, t);
  }
  pluralize(r, t, n) {
    return yn({
      i18n: this,
      count: r,
      scope: t,
      options: Object.assign({}, n),
      baseScope: ze(this, t, n ?? {})
    });
  }
  localize(r, t, n) {
    if (n = Object.assign({}, n), t == null)
      return "";
    switch (r) {
      case "currency":
        return this.numberToCurrency(t);
      case "number":
        return Je(t, Object.assign({ delimiter: ",", precision: 3, separator: ".", significant: !1, stripInsignificantZeros: !1 }, $e(this, "number.format")));
      case "percentage":
        return this.numberToPercentage(t);
      default: {
        let a;
        return r.match(/^(date|time)/) ? a = this.toTime(r, t) : a = t.toString(), Mr(this, a, n);
      }
    }
  }
  toTime(r, t) {
    const n = Zr(t), a = $e(this, r);
    return n.toString().match(/invalid/i) || !a ? n.toString() : this.strftime(n, a);
  }
  numberToCurrency(r, t = {}) {
    return Je(r, Object.assign(Object.assign(Object.assign({ delimiter: ",", format: "%u%n", precision: 2, separator: ".", significant: !1, stripInsignificantZeros: !1, unit: "$" }, me(this.get("number.format"))), me(this.get("number.currency.format"))), t));
  }
  numberToPercentage(r, t = {}) {
    return Je(r, Object.assign(Object.assign(Object.assign({ delimiter: "", format: "%n%", precision: 3, stripInsignificantZeros: !1, separator: ".", significant: !1 }, me(this.get("number.format"))), me(this.get("number.percentage.format"))), t));
  }
  numberToHumanSize(r, t = {}) {
    return q4(this, r, Object.assign(Object.assign(Object.assign({ delimiter: "", precision: 3, significant: !0, stripInsignificantZeros: !0, units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, me(this.get("number.human.format"))), me(this.get("number.human.storage_units"))), t));
  }
  numberToHuman(r, t = {}) {
    return V4(this, r, Object.assign(Object.assign(Object.assign({ delimiter: "", separator: ".", precision: 3, significant: !0, stripInsignificantZeros: !0, format: "%n %u", roundMode: "default", units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, me(this.get("number.human.format"))), me(this.get("number.human.decimal_units"))), t));
  }
  numberToRounded(r, t) {
    return Je(r, Object.assign({ unit: "", precision: 3, significant: !1, separator: ".", delimiter: "", stripInsignificantZeros: !1 }, t));
  }
  numberToDelimited(r, t = {}) {
    return of(r, Object.assign({ delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g, delimiter: ",", separator: "." }, t));
  }
  withLocale(r, t) {
    return mp(this, void 0, void 0, function* () {
      const n = this.locale;
      try {
        this.locale = r, yield t();
      } finally {
        this.locale = n;
      }
    });
  }
  strftime(r, t, n = {}) {
    return tp(r, t, Object.assign(Object.assign(Object.assign({}, me($e(this, "date"))), { meridian: {
      am: $e(this, "time.am") || "AM",
      pm: $e(this, "time.pm") || "PM"
    } }), n));
  }
  update(r, t, n = { strict: !1 }) {
    if (n.strict && !D1(this.translations, r))
      throw new Error(`The path "${r}" is not currently defined`);
    const a = Br(this.translations, r), o = Me(a), d = Me(t);
    if (n.strict && o !== d)
      throw new Error(`The current type for "${r}" is "${o}", but you're trying to override it with "${d}"`);
    let b;
    d === "object" ? b = Object.assign(Object.assign({}, a), t) : b = t, r0(this.translations, r, b), this.hasChanged();
  }
  toSentence(r, t = {}) {
    const { wordsConnector: n, twoWordsConnector: a, lastWordConnector: o } = Object.assign(Object.assign({ wordsConnector: ", ", twoWordsConnector: " and ", lastWordConnector: ", and " }, me($e(this, "support.array"))), t), d = r.length;
    switch (d) {
      case 0:
        return "";
      case 1:
        return `${r[0]}`;
      case 2:
        return r.join(a);
      default:
        return [
          r.slice(0, d - 1).join(n),
          o,
          r[d - 1]
        ].join("");
    }
  }
  timeAgoInWords(r, t, n = {}) {
    return gp(this, r, t, n);
  }
  onChange(r) {
    return this.onChangeHandlers.push(r), () => {
      this.onChangeHandlers.splice(this.onChangeHandlers.indexOf(r), 1);
    };
  }
  get version() {
    return this._version;
  }
  formatNumber(r, t) {
    return Je(r, t);
  }
  get(r) {
    return $e(this, r);
  }
  runCallbacks() {
    this.onChangeHandlers.forEach((r) => r(this));
  }
  hasChanged() {
    this._version += 1, this.runCallbacks();
  }
}
const xa = "en-US", $p = () => {
  const e = new $a();
  return e.defaultLocale = xa, e.enableFallback = !0, e;
}, Jr = xn({
  i18n: new $a(),
  setLocale: (e) => new Promise((r) => r)
}), Tp = ({
  children: e,
  onChangeLocale: r,
  locale: t = xa,
  shouldWaitForTranslations: n = !0
}) => {
  const a = Xr($p()), [o, d] = lr(t), [b, m] = lr(!1), [x, C] = lr(!1);
  cr(() => {
    window.I18nContext = Jr, m(!0);
  }, []), cr(() => {
    t && E(t);
  }, [t]);
  const E = async (T) => {
    if (T === a.current.locale)
      return;
    a.current.locale = T;
    const R = await r(T);
    a.current.store(R), C(!0), d(T);
  };
  return /* @__PURE__ */ O.jsx(
    Jr.Provider,
    {
      value: { i18n: a.current, setLocale: E },
      children: b && (n && x || !n) ? e : null
    }
  );
};
Jr.displayName = "I18nContext";
const Ap = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    fill: "none",
    width: r,
    height: e,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#00CD82",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M68.443 124.457c2.32 2.321 5.374 3.543 8.672 3.543 3.297 0 6.35-1.344 8.671-3.543L138.427 71.8a12.168 12.168 0 000-17.226 12.16 12.16 0 00-17.221 0L76.992 98.556 58.794 80.352a12.16 12.16 0 00-17.221 0 12.17 12.17 0 000 17.227l26.87 26.878z"
        }
      )
    ]
  }
)), jp = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    fill: "none",
    width: r,
    height: e,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#A0A0A0",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M127.2 117.152l-25.9-27.1 26-27.1c3.1-3.3 2.9-8.5-.3-11.7-3.3-3.1-8.6-3-11.7.3l-25.5 26.6-25.4-26.6c-3.1-3.3-8.4-3.4-11.7-.3-3.3 3.1-3.4 8.4-.3 11.7l25.9 27.1-26 27.1c-1.5 1.6-2.3 3.7-2.3 5.9s1 4.3 2.5 5.7c1.5 1.5 3.5 2.3 5.8 2.3 2.2 0 4.4-.9 6-2.5l25.4-26.6 25.4 26.6c1.6 1.6 3.7 2.5 6 2.5 2.1 0 4.1-.8 5.7-2.3 1.6-1.5 2.5-3.6 2.6-5.8.1-2.1-.7-4.2-2.2-5.8z"
        }
      )
    ]
  }
)), Pp = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    height: e,
    width: r,
    fill: "none",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "url(#paint0_linear_352_4279)",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M33 57.364C33 46.666 41.657 38 52.326 38h74.348C137.343 38 146 46.661 146 57.364v45.478c0 10.698-8.657 19.364-19.326 19.364h-38.57L61.217 151v-28.794h-8.89c-10.67 0-19.327-8.661-19.327-19.364V57.364zm19.326-13.633c-7.521 0-13.613 6.108-13.613 13.633v45.478c0 7.529 6.09 13.633 13.613 13.633H66.93v20.024l18.697-20.024h41.047c7.521 0 13.613-6.107 13.613-13.633V57.364c0-7.529-6.091-13.633-13.613-13.633H52.326z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M33 57.364C33 46.666 41.657 38 52.326 38h74.348C137.343 38 146 46.661 146 57.364v45.478c0 10.698-8.657 19.364-19.326 19.364h-38.57L61.217 151v-28.794h-8.89c-10.67 0-19.327-8.661-19.327-19.364V57.364zm19.326-13.633c-7.521 0-13.613 6.108-13.613 13.633v45.478c0 7.529 6.09 13.633 13.613 13.633H66.93v20.024l18.697-20.024h41.047c7.521 0 13.613-6.107 13.613-13.633V57.364c0-7.529-6.091-13.633-13.613-13.633H52.326z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M89.5 93.442l-11.934 6.2c-1.647.857-2.723.106-2.405-1.666l2.345-13.062-9.714-9.191c-1.34-1.269-.943-2.502.916-2.76l13.38-1.848 5.93-11.88c.818-1.64 2.14-1.652 2.964 0l5.93 11.88 13.379 1.849c1.847.255 2.267 1.481.916 2.759l-9.713 9.191 2.345 13.062c.319 1.776-.747 2.529-2.406 1.667l-11.933-6.2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ O.jsx("defs", { children: /* @__PURE__ */ O.jsxs(
        "linearGradient",
        {
          id: "paint0_linear_352_4279",
          x1: "159.5",
          x2: "46.5",
          y1: "32",
          y2: "160.5",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ O.jsx("stop", { stopColor: "#14D7A7" }),
            /* @__PURE__ */ O.jsx(
              "stop",
              {
                offset: "0.45",
                stopColor: "#19B393"
              }
            ),
            /* @__PURE__ */ O.jsx(
              "stop",
              {
                offset: "1",
                stopColor: "#274C5C"
              }
            )
          ]
        }
      ) })
    ]
  }
)), Rp = _e(({ width: e, height: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    height: r,
    width: e,
    fill: "none",
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#DA0000",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M127.2 117.152l-25.9-27.1 26-27.1c3.1-3.3 2.9-8.5-.3-11.7-3.3-3.1-8.6-3-11.7.3l-25.5 26.6-25.4-26.6c-3.1-3.3-8.4-3.4-11.7-.3-3.3 3.1-3.4 8.4-.3 11.7l25.9 27.1-26 27.1c-1.5 1.6-2.3 3.7-2.3 5.9s1 4.3 2.5 5.7c1.5 1.5 3.5 2.3 5.8 2.3 2.2 0 4.4-.9 6-2.5l25.4-26.6 25.4 26.6c1.6 1.6 3.7 2.5 6 2.5 2.1 0 4.1-.8 5.7-2.3 1.6-1.5 2.5-3.6 2.6-5.8.1-2.1-.7-4.2-2.2-5.8z"
        }
      )
    ]
  }
)), Ip = _e(({ width: e, height: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    height: r,
    width: e,
    fill: "none",
    viewBox: "0 0 180 180",
    children: [
      /* @__PURE__ */ O.jsx(
        "rect",
        {
          width: "180",
          height: "180",
          fill: "url(#paint0_radial_354_4353)",
          rx: "90"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "rect",
        {
          width: "180",
          height: "180",
          fill: "url(#paint1_radial_354_4353)",
          rx: "90"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M89.667 33c-15.39 0-17.32.065-23.363.341-6.032.275-10.152 1.232-13.756 2.633-3.727 1.449-6.887 3.386-10.037 6.537-3.15 3.15-5.088 6.31-6.536 10.037-1.4 3.604-2.359 7.723-2.634 13.755-.276 6.044-.341 7.973-.341 23.364 0 15.389.065 17.32.341 23.364.275 6.03 1.234 10.15 2.634 13.754 1.448 3.727 3.386 6.887 6.536 10.038 3.15 3.149 6.31 5.086 10.037 6.536 3.604 1.4 7.724 2.358 13.756 2.633 6.043.276 7.973.341 23.363.341 15.389 0 17.318-.065 23.362-.341 6.034-.275 10.152-1.233 13.756-2.633 3.727-1.45 6.887-3.387 10.038-6.536 3.149-3.151 5.088-6.311 6.536-10.038 1.4-3.604 2.358-7.724 2.633-13.754.276-6.044.341-7.975.341-23.364 0-15.39-.065-17.32-.341-23.364-.275-6.032-1.233-10.151-2.633-13.755-1.448-3.727-3.387-6.887-6.536-10.037-3.151-3.151-6.311-5.089-10.038-6.537-3.604-1.4-7.722-2.358-13.756-2.633-6.044-.276-7.973-.341-23.362-.341zm0 10.21c15.13 0 16.922.058 22.898.33 5.524.253 8.524 1.176 10.522 1.952 2.645 1.027 4.533 2.256 6.516 4.239 1.982 1.982 3.21 3.87 4.238 6.515.776 1.996 1.699 4.997 1.952 10.522.272 5.976.331 7.768.331 22.899 0 15.13-.059 16.922-.331 22.898-.253 5.524-1.176 8.526-1.952 10.522-1.028 2.645-2.256 4.533-4.238 6.516-1.983 1.982-3.871 3.21-6.516 4.238-1.998.776-4.998 1.7-10.522 1.952-5.976.272-7.766.33-22.898.33s-16.924-.058-22.899-.33c-5.524-.252-8.525-1.176-10.521-1.952-2.646-1.028-4.534-2.256-6.516-4.238-1.983-1.983-3.211-3.871-4.239-6.516-.776-1.996-1.699-4.998-1.952-10.522-.272-5.976-.33-7.768-.33-22.898 0-15.131.058-16.923.33-22.9.253-5.524 1.176-8.524 1.952-10.52 1.028-2.646 2.256-4.534 4.239-6.516 1.982-1.983 3.87-3.212 6.516-4.239 1.996-.776 4.997-1.699 10.521-1.952 5.976-.272 7.768-.33 22.899-.33z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M89.667 108.556c-10.432 0-18.89-8.457-18.89-18.89 0-10.431 8.458-18.889 18.89-18.889s18.889 8.458 18.889 18.89-8.457 18.889-18.89 18.889zm0-47.988c-16.071 0-29.1 13.028-29.1 29.099 0 16.07 13.029 29.098 29.1 29.098 16.072 0 29.098-13.028 29.098-29.098 0-16.071-13.026-29.099-29.098-29.099zM126.714 59.417a6.799 6.799 0 11-13.598 0 6.8 6.8 0 0113.598 0z"
        }
      ),
      /* @__PURE__ */ O.jsxs("defs", { children: [
        /* @__PURE__ */ O.jsxs(
          "radialGradient",
          {
            id: "paint0_radial_354_4353",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.244",
                  stopColor: "#FF1B90"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.437",
                  stopColor: "#F80261"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.688",
                  stopColor: "#ED00C0"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.777",
                  stopColor: "#C500E9"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.893",
                  stopColor: "#7017FF"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ O.jsxs(
          "radialGradient",
          {
            id: "paint1_radial_354_4353",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.094",
                  stopColor: "#FFD000"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.443",
                  stopColor: "#FF6930"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "0.693",
                  stopColor: "#FE3B36"
                }
              ),
              /* @__PURE__ */ O.jsx(
                "stop",
                {
                  offset: "1",
                  stopColor: "#FF6930",
                  stopOpacity: "0"
                }
              )
            ]
          }
        )
      ] })
    ]
  }
)), Mp = _e(
  ({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: e,
      width: r,
      fill: "none",
      viewBox: "0 0 180 180",
      children: [
        /* @__PURE__ */ O.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint0_radial_354_4349)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ O.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint1_radial_354_4349)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ O.jsx(
          "path",
          {
            fill: "#fff",
            d: "M89.98 151.516c-10.045 0-20.008-2.485-28.815-7.186a4.227 4.227 0 113.983-7.458c7.585 4.05 16.172 6.19 24.831 6.19 4.069 0 8.123-.464 12.046-1.379a4.225 4.225 0 015.078 3.156 4.227 4.227 0 01-3.157 5.078 61.628 61.628 0 01-13.967 1.599zM50.762 135.893a4.207 4.207 0 01-2.906-1.159c-8.61-8.156-14.63-18.525-17.41-29.987a4.228 4.228 0 118.217-1.992c2.394 9.874 7.585 18.809 15.008 25.841a4.227 4.227 0 01-2.909 7.297zM33.233 88.806a4.226 4.226 0 01-4.212-4.644 60.82 60.82 0 015.395-19.73 4.228 4.228 0 017.665 3.57 52.35 52.35 0 00-4.646 16.993 4.228 4.228 0 01-4.202 3.811zM50.966 53.002a4.227 4.227 0 01-3.264-6.91c.377-.46.76-.913 1.15-1.361a4.225 4.225 0 015.965-.41 4.226 4.226 0 01.41 5.964 54.11 54.11 0 00-.991 1.173 4.221 4.221 0 01-3.27 1.544zM119.235 143.453a4.228 4.228 0 01-2.176-7.855c15.865-9.499 25.722-26.872 25.722-45.339 0-29.115-23.688-52.803-52.803-52.803a4.228 4.228 0 110-8.456c33.778 0 61.258 27.48 61.258 61.258 0 21.424-11.432 41.577-29.835 52.593a4.183 4.183 0 01-2.166.602z"
          }
        ),
        /* @__PURE__ */ O.jsx(
          "path",
          {
            fill: "#fff",
            d: "M118.553 86.25H94.332V62.03h-8.456v24.22h-24.22v8.455h24.22v24.222h8.456V94.705h24.221V86.25z"
          }
        ),
        /* @__PURE__ */ O.jsxs("defs", { children: [
          /* @__PURE__ */ O.jsxs(
            "radialGradient",
            {
              id: "paint0_radial_354_4349",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.244",
                    stopColor: "#FF1B90"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.437",
                    stopColor: "#F80261"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.688",
                    stopColor: "#ED00C0"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.777",
                    stopColor: "#C500E9"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.893",
                    stopColor: "#7017FF"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ O.jsxs(
            "radialGradient",
            {
              id: "paint1_radial_354_4349",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.094",
                    stopColor: "#FFD000"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.443",
                    stopColor: "#FF6930"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.693",
                    stopColor: "#FE3B36"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "1",
                    stopColor: "#FF6930",
                    stopOpacity: "0"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  )
), Np = _e(
  ({ width: e, height: r }) => /* @__PURE__ */ O.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: r,
      width: e,
      fill: "none",
      viewBox: "0 0 180 180",
      children: [
        /* @__PURE__ */ O.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint0_radial_357_4364)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ O.jsx(
          "rect",
          {
            width: "180",
            height: "180",
            fill: "url(#paint1_radial_357_4364)",
            rx: "90"
          }
        ),
        /* @__PURE__ */ O.jsx("g", { clipPath: "url(#clip0_357_4364)", children: /* @__PURE__ */ O.jsx(
          "path",
          {
            fill: "#fff",
            d: "M64.14 29H116c9.65 0 18.43 3.96 24.8 10.32 6.38 6.37 10.34 15.16 10.34 24.82v52.61c0 9.64-3.96 18.42-10.32 24.79l-.02.02c-6.38 6.37-15.16 10.32-24.79 10.32H64.14c-9.66 0-18.45-3.96-24.82-10.32l-.24-.27C32.86 134.95 29 126.27 29 116.74v-52.6c0-9.67 3.95-18.45 10.32-24.82C45.69 32.95 54.47 29 64.14 29zm56.37 31.02l.07.11h21.6c-.87-5.68-3.58-10.78-7.48-14.69-4.8-4.8-11.42-7.78-18.7-7.78h-8.87l13.38 22.36zm-9.99.11L97.07 37.66h-29.5l13.61 22.47h29.34zm-39.41 0L57.95 38.39a26.446 26.446 0 00-12.51 7.05c-3.9 3.9-6.6 9.01-7.48 14.69h33.15zm71.37 8.66H37.66v47.96c0 7.17 2.89 13.7 7.56 18.48l.22.21c4.8 4.8 11.43 7.79 18.7 7.79H116c7.28 0 13.9-2.98 18.69-7.77l.02-.02c4.79-4.79 7.77-11.41 7.77-18.69V68.79zM79.95 83.95l26.83 17.45c.43.28.82.64 1.13 1.08a3.9 3.9 0 01-1 5.42l-26.72 15.77c-.67.55-1.53.88-2.48.88a3.91 3.91 0 01-3.91-3.91V87.15h.02a3.902 3.902 0 016.13-3.2z"
          }
        ) }),
        /* @__PURE__ */ O.jsxs("defs", { children: [
          /* @__PURE__ */ O.jsxs(
            "radialGradient",
            {
              id: "paint0_radial_357_4364",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-106.74055 -221.03968 328.77111 -158.7643 152.1 204.3)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.244",
                    stopColor: "#FF1B90"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.437",
                    stopColor: "#F80261"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.688",
                    stopColor: "#ED00C0"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.777",
                    stopColor: "#C500E9"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.893",
                    stopColor: "#7017FF"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ O.jsxs(
            "radialGradient",
            {
              id: "paint1_radial_357_4364",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(61.37989 -85.67985 93.71724 67.13776 60.3 180)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.094",
                    stopColor: "#FFD000"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.443",
                    stopColor: "#FF6930"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "0.693",
                    stopColor: "#FE3B36"
                  }
                ),
                /* @__PURE__ */ O.jsx(
                  "stop",
                  {
                    offset: "1",
                    stopColor: "#FF6930",
                    stopOpacity: "0"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ O.jsx("clipPath", { id: "clip0_357_4364", children: /* @__PURE__ */ O.jsx(
            "path",
            {
              fill: "#fff",
              d: "M0 0H122.14V122.88H0z",
              transform: "translate(29 29)"
            }
          ) })
        ] })
      ]
    }
  )
), Fp = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: e,
    width: r,
    viewBox: "0 0 180 180",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#4A90E2",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M133.381 125.5h-14.504V79.127h-17.978v-10.93c2.52.069 4.937-.101 7.253-.51 2.383-.477 4.494-1.26 6.332-2.35a15.91 15.91 0 004.801-4.493c1.294-1.839 2.145-4.12 2.554-6.844h11.542v71.5zM68.256 94.244h20.326v10.929H68.256v20.326h-10.93v-20.326H37v-10.93h20.326V73.918h10.93v20.327z"
        }
      )
    ]
  }
)), Dp = _e(({ width: e, height: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    viewBox: "0 0 181 181",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "mask",
        {
          id: "mask0_352_4285",
          style: { maskType: "luminance" },
          width: "181",
          height: "181",
          x: "0",
          y: "0",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ O.jsx(
            "path",
            {
              fill: "#fff",
              d: "M180.113 90.547c0-49.707-40.294-90.007-90-90.007-49.705 0-90 40.3-90 90.007 0 49.693 40.295 90 90 90 49.706 0 90-40.307 90-90z"
            }
          )
        }
      ),
      /* @__PURE__ */ O.jsx("g", { mask: "url(#mask0_352_4285)", children: /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "url(#paint0_linear_352_4285)",
          d: "M180.113 90.547c0-49.707-40.294-90.007-90-90.007-49.705 0-90 40.3-90 90.007 0 49.693 40.295 90 90 90 49.706 0 90-40.307 90-90z"
        }
      ) }),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#C8DAEA",
          d: "M61.035 97.12l10.678 29.56s1.335 2.76 2.764 2.76c1.431 0 22.691-22.12 22.691-22.12l23.644-45.667-59.396 27.84-.381 7.627z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#A9C6D8",
          d: "M75.193 104.693l-2.05 21.787s-.86 6.68 5.815 0c6.674-6.667 13.062-11.813 13.062-11.813l-16.827-9.974z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M61.228 98.173l-21.962-7.16s-2.622-1.066-1.78-3.48c.174-.493.525-.92 1.573-1.653 4.868-3.387 90.08-34.013 90.08-34.013s2.406-.814 3.828-.267c.649.24 1.064.52 1.414 1.533.127.374.2 1.16.191 1.934-.008.573-.077 1.093-.128 1.92-.519 8.373-16.047 70.866-16.047 70.866s-.929 3.654-4.258 3.774c-1.214.053-2.688-.2-4.45-1.707-6.532-5.627-29.113-20.8-34.104-24.133-.28-.187-.36-.44-.409-.68-.07-.347.313-.787.313-.787s39.319-34.947 40.366-38.613c.081-.28-.223-.427-.635-.307-2.612.96-47.884 29.547-52.88 32.707-.292.186-1.112.066-1.112.066z"
        }
      ),
      /* @__PURE__ */ O.jsx("defs", { children: /* @__PURE__ */ O.jsxs(
        "linearGradient",
        {
          id: "paint0_linear_352_4285",
          x1: "90.113",
          x2: "90.113",
          y1: "180.547",
          y2: "0.547",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ O.jsx("stop", { stopColor: "#1D93D2" }),
            /* @__PURE__ */ O.jsx(
              "stop",
              {
                offset: "1",
                stopColor: "#38B0E3"
              }
            )
          ]
        }
      ) })
    ]
  }
)), Lp = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    fill: "none",
    width: r,
    height: e,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#010201",
          d: "M180 90c0 49.705-40.295 90-90 90S0 139.705 0 90 40.295 0 90 0s90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M65.98 126.121l.323.295c.996.713 1.716 1.716 2.67 2.481 2.96 2.376 6.288 3.668 10.105 3.904 9.043.559 16.924-6.246 17.945-15.189.05-.437.032-.876.032-1.313.002-26.923.002-53.846.002-80.77 0-1.816 0-1.816 1.808-1.816 4.092 0 8.182-.002 12.273.003.384 0 .785-.072 1.135.17l.073.055c.196.203.253.463.311.727 1.568 7.256 5.386 13.047 11.377 17.417.373.274.687.615 1.045.906.262.22.523.442.783.664.967.548 1.649 1.43 2.488 2.13 3.312 2.76 7.051 4.662 11.221 5.735.368.095.787.09 1.055.437l.067.059c.245.259.204.588.204.899.004 4.746.006 9.493 0 14.24-.002 1.086-.147 1.141-1.244 1.142-3.478.004-6.891-.465-10.271-1.237-5.809-1.33-11.172-3.69-16.144-6.957-.26-.17-.535-.535-.811-.41-.352.16-.166.612-.166.932-.01 13.364.049 26.727-.028 40.09-.054 9.342-3.024 17.7-9.14 24.818-6.498 7.563-14.75 11.954-24.657 13.163-7.635.933-14.88-.448-21.755-3.844a19.94 19.94 0 01-3.17-1.94l-.94-.833c-2.37-1.956-4.02-4.49-5.558-7.087-2.37-4-3.908-8.317-4.659-12.909-.43-2.624-.648-5.27-.502-7.924.466-8.556 3.345-16.192 8.864-22.792 4.629-5.538 10.407-9.406 17.22-11.731a34.638 34.638 0 018.78-1.783c.558-.04 1.108-.172 1.672-.137.266.017.54-.01.767.175l.083.056c.157.269.119.568.119.856.004 4.817.002 9.633.002 14.45 0 .17-.005.34-.013.511-.023.483-.27.644-.727.515-1.317-.375-2.67-.548-4.03-.62a15.343 15.343 0 00-6.168.917c-6.62 2.443-10.64 7.184-11.479 14.169-.828 6.887 1.89 12.394 7.617 16.359.48.333.972.643 1.42 1.017z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#CB1C54",
          d: "M53.51 142.912c.257-.069.402.134.58.242a38.164 38.164 0 0013.927 5.142c2.503.403 5.032.572 7.564.441 8.472-.441 16.052-3.258 22.608-8.674 6.31-5.214 10.503-11.802 12.602-19.712.661-2.498 1.026-5.042 1.157-7.626.076-1.485.069-2.969.071-4.453.004-12.735.002-25.47.002-38.203v-.868c.332-.09.482.158.666.283 4.534 3.104 9.442 5.403 14.742 6.861a49.737 49.737 0 008.878 1.6c1.265.11 2.53.095 3.793.187.552.04.56.018.565-.559.008-.61.003-1.218.003-1.826v-12.93c.001-.268.017-.535.025-.801 1.136.128 2.254.372 3.395.457.705.053 1.409.119 2.116.098.349-.011.496.111.457.462-.017.144-.002.292-.002.438v18.698c0 .123.002.244-.002.365-.014.543-.014.555-.588.554a45.497 45.497 0 01-5.826-.39 49.391 49.391 0 01-11.494-2.934 49.164 49.164 0 01-10.037-5.31c-.195-.134-.397-.257-.697-.45v.873c0 13.61.01 27.22-.004 40.831-.008 7.253-1.887 13.993-5.756 20.141-4.674 7.424-11.162 12.646-19.406 15.643-5.005 1.819-10.182 2.516-15.502 2.124-8.974-.663-16.738-4.089-23.344-10.171-.178-.162-.328-.354-.492-.533z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M112.274 33.887c-.267.013-.532.037-.799.037l-13.153.001c-1.017 0-1.017 0-1.017.984 0 26.782-.003 53.564.006 80.347.002 1.861-.137 3.696-.72 5.469-2.058 6.27-6.26 10.4-12.688 11.867-6.894 1.573-12.748-.529-17.406-5.873l-.192-.303c1.332.529 2.66 1.063 4.076 1.343 4.493.888 8.728.202 12.625-2.202 4.503-2.776 7.161-6.84 8.095-12.032.176-.98.204-1.98.204-2.98-.006-26.833-.004-53.666-.002-80.498 0-1.251-.174-1.095 1.071-1.095 6.187-.005 12.375-.003 18.561-.003.147 0 .294-.002.439 0 .633.01.645.01.641.652-.006 1.435-.024 2.868.259 4.286z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M79.156 77.89c-3.78.127-7.477.726-11.073 1.92-5.192 1.727-9.804 4.431-13.828 8.14-5.279 4.866-8.879 10.766-10.847 17.656-.701 2.456-1.108 4.97-1.287 7.523a37.452 37.452 0 00-.058 4.592c.226 4.248 1.106 8.361 2.722 12.311 1.806 4.412 4.332 8.356 7.622 11.81l.164.235c-.747-.32-1.348-.863-1.97-1.359-6.14-4.865-10.466-11-12.848-18.476a37.578 37.578 0 01-1.594-7.988 37.343 37.343 0 01-.078-5.906 37.308 37.308 0 013.238-13.022c1.954-4.328 4.621-8.17 8.012-11.492 3.948-3.869 8.522-6.766 13.733-8.64a37.845 37.845 0 0110.097-2.14 39.17 39.17 0 017.502.167c.337.04.536.108.528.51-.027 1.386-.026 2.773-.035 4.16z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#CB1C54",
          d: "M65.98 126.121c-1.525-.687-2.842-1.681-4.037-2.831-3.002-2.89-4.79-6.414-5.253-10.556-.972-8.689 4.507-16.189 12.115-18.513 3.247-.992 6.5-1.028 9.771-.15.183.05.363.129.565.076.108-.262.054-.533.054-.795.004-4.868.002-9.737.004-14.607 0-.265.027-.532.04-.799 1.879-.127 3.743.042 5.607.25.293.032.372.17.364.424-.005.146 0 .292 0 .438 0 6.451.001 12.902-.003 19.351-.001.236.066.485-.09.741-.848-.16-1.683-.416-2.548-.537-4.982-.697-9.478.468-13.425 3.576-3.469 2.732-5.602 6.323-6.318 10.673-.761 4.612.193 8.892 2.848 12.77.108.158.204.326.307.489zM125.08 52.99c-1.876-1.108-3.519-2.509-5.029-4.064-4.055-4.172-6.616-9.125-7.702-14.84l-.002-.145c1.749-.1 3.5-.012 5.25-.047.311-.006.448.118.419.43-.012.121 0 .244-.001.365-.091 4.905 1.366 9.386 3.756 13.605.853 1.506 1.876 2.897 2.989 4.222.123.145.297.26.32.474z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#6ABAC5",
          d: "M140.627 61.957c-4.989-1.065-9.377-3.314-13.182-6.701-.56-.499-1.138-.985-1.582-1.601.186-.02.32.094.467.178a28.908 28.908 0 009.689 3.432c1.339.222 2.691.366 4.055.352.568-.005.583.016.583.558-.002 1.261-.019 2.52-.03 3.782z"
        }
      )
    ]
  }
)), Up = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    fill: "none",
    width: r,
    height: e,
    viewBox: "0 0 181 181",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#9146FF",
          fillRule: "evenodd",
          d: "M180.113 90.85c0 49.705-40.294 89.999-90 89.999-49.705 0-90-40.294-90-90s40.295-90 90-90c49.706 0 90 40.294 90 90z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M134.557 93.072l-17.777 17.777H99.001l-15.554 15.556v-15.556h-20V44.183h71.11v48.889z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#000",
          d: "M134.558 93.072L116.78 110.85H99.002l-15.555 15.556v-15.556h-20V44.183h71.111v48.89zM59.002 35.295L36.78 57.516v80h26.667v22.223l22.221-22.223h17.779l40-40V35.295H59.002z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#000",
          d: "M112.334 59.739h8.89v26.666h-8.89V59.74zM87.89 59.739h8.89v26.666h-8.89V59.74z"
        }
      )
    ]
  }
)), zp = _e(({ height: e, width: r }) => /* @__PURE__ */ O.jsxs(
  "svg",
  {
    fill: "none",
    viewBox: "0 0 180 181",
    width: r,
    height: e,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#DA0000",
          d: "M180 90.952c0 49.705-40.295 90-90 90s-90-40.295-90-90 40.295-90 90-90 90 40.295 90 90z"
        }
      ),
      /* @__PURE__ */ O.jsx(
        "path",
        {
          fill: "#fff",
          d: "M78 108.952v-36l31.176 18-31.176 18zm69.492-46.883a15.028 15.028 0 00-10.609-10.609C127.525 48.952 90 48.952 90 48.952s-37.525 0-46.884 2.508a15.029 15.029 0 00-10.608 10.61C30 71.426 30 90.951 30 90.951s0 19.525 2.508 28.883a15.026 15.026 0 0010.608 10.609C52.475 132.952 90 132.952 90 132.952s37.525 0 46.883-2.508a15.025 15.025 0 0010.609-10.609C150 110.477 150 90.952 150 90.952s0-19.525-2.508-28.883z"
        }
      )
    ]
  }
)), xp = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
};
function wp({
  key: e,
  type: r = "session"
  /* SESSION */
}) {
  try {
    const t = (r === "local" ? window.localStorage : window.sessionStorage).getItem(e);
    return t ? xp(t) : null;
  } catch {
    return console.warn("We can not get the data from storage"), null;
  }
}
const wa = async ({
  event: e,
  endpoint: r,
  properties: t,
  accessTokenSetup: n
}) => {
  const a = JSON.stringify({
    event: e,
    properties: t
  }), { key: o, type: d } = n, b = wp({
    key: o,
    type: d
  }) || "";
  await fetch(r, {
    body: a,
    method: "POST",
    keepalive: !0,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Token": b
    }
  });
}, ct = xn({
  addEvent: () => new Promise((e) => e)
}), Bp = ({ endpoint: e, accessTokenSetup: r, children: t }) => {
  const n = (a, o = {}) => wa({ event: a, endpoint: e, properties: o, accessTokenSetup: r });
  return /* @__PURE__ */ O.jsx(ct.Provider, { value: { addEvent: n }, children: t });
}, kp = ({ endpoint: e, accessTokenSetup: r, children: t, storeId: n, clientId: a }) => {
  const o = (d, b = {}) => wa({
    event: d,
    properties: {
      client_id: a,
      store_id: n,
      ...b
    },
    endpoint: e,
    accessTokenSetup: r
  });
  return /* @__PURE__ */ O.jsx(ct.Provider, { value: { addEvent: o }, children: t });
}, Hp = () => $n(ct);
export {
  Ap as Approve,
  jp as Cancel,
  Pp as Consumer,
  Rp as Decline,
  Jr as I18nContext,
  Tp as I18nProvider,
  Ip as Instagram,
  Np as InstagramReels,
  Mp as InstagramStory,
  Fp as Order,
  Dp as Ship,
  Lp as TikTok,
  ct as TrackingEventContext,
  Bp as TrackingEventCreatorProvider,
  kp as TrackingEventProProvider,
  Up as Twitch,
  zp as Youtube,
  Cp as useClickOutside,
  Sp as useDebounce,
  Ep as useI18n,
  Hp as useTrackingEvent
};
